// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Container */
.dashboard-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Header */
.dashboard-header {
  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);
  color: #495057;
  border-bottom: 2px solid #636e72;
  padding: 0.75rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-logo {
  width: 58px;
  height: 58px;
  object-fit: contain;
}

.title-container {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
}

.header-title {
  color: #FFD700;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 2px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.version-text {
  color: #495057;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  opacity: 0.8;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.header-nav {
  display: flex;
  gap: 1rem;
}

.nav-button {
  background: transparent;
  border: 2px solid #636e72;
  color: #495057;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.nav-button:hover {
  background: rgba(255, 215, 0, 0.1);
  border-color: #FFD700;
}

.nav-button.active {
  background: #FFD700;
  color: #2d3436;
  border-color: #FFD700;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-info {
  color: #495057;
  font-weight: 500;
}

.logout-button {
  background: rgba(220, 53, 69, 0.8);
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.logout-button:hover {
  background: rgba(220, 53, 69, 1);
}

/* Main Content */
.dashboard-main {
  padding: 2rem;
}

.dashboard-content {
  max-width: 1400px;
  margin: 0 auto;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.content-header h2 {
  color: #ffffff;
  font-size: 2rem;
  margin: 0;
  font-weight: 600;
}

.status-indicators {
  display: flex;
  gap: 2rem;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.status-led {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.status-led.active {
  background: #28a745;
  box-shadow: 0 0 8px #28a745;
}

.status-led.warning {
  background: #ffc107;
  box-shadow: 0 0 8px #ffc107;
}

.status-led.critical {
  background: #dc3545;
  box-shadow: 0 0 8px #dc3545;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

/* Indicators Grid */
.indicators-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.indicator-card {
  background: rgba(248, 249, 250, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.indicator-card:hover {
  background: rgba(248, 249, 250, 0.15);
  border-color: rgba(255, 215, 0, 0.3);
}

.indicator-card.large {
  grid-column: span 2;
}

.indicator-card.wide {
  grid-column: span 3;
}

.indicator-card h3 {
  color: #ddd;
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

/* Gauge Display */
.gauge-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
}

.gauge-display {
  text-align: center;
}

.gauge-value {
  display: block;
  font-size: 3rem;
  font-weight: 700;
  color: #FFD700;
  line-height: 1;
}

.gauge-unit {
  font-size: 1.2rem;
  color: #ccc;
  font-weight: 500;
}

/* Metric Display */
.metric-display {
  text-align: center;
  padding: 1rem 0;
}

.metric-value {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
}

.metric-unit {
  font-size: 1rem;
  color: #aaa;
  font-weight: 500;
}

/* Chart Placeholder */
.chart-placeholder {
  height: 100px;
  display: flex;
  align-items: end;
  justify-content: center;
}

.chart-bars {
  display: flex;
  gap: 8px;
  height: 80px;
  align-items: end;
}

.bar {
  width: 20px;
  background: linear-gradient(to top, #FFD700, #ffa500);
  border-radius: 2px 2px 0 0;
  min-height: 10px;
}

/* Alerts List */
.alerts-list {
  space-y: 0.5rem;
}

.alert-item {
  display: flex;
  gap: 1rem;
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  border-left: 4px solid;
}

.alert-item.critical {
  background: rgba(220, 53, 69, 0.1);
  border-left-color: #dc3545;
}

.alert-item.warning {
  background: rgba(255, 193, 7, 0.1);
  border-left-color: #ffc107;
}

.alert-time {
  color: #aaa;
  font-weight: 600;
  min-width: 60px;
}

.alert-message {
  color: #fff;
  flex: 1 1;
}

/* Responsive */
@media (max-width: 1200px) {
  .indicator-card.large,
  .indicator-card.wide {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    padding: 0.5rem 1rem;
    flex-direction: column;
    gap: 1rem;
  }
  
  .content-header {
    flex-direction: column;
    gap: 1rem;
    align-items: start;
  }
  
  .status-indicators {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .dashboard-main {
    padding: 1rem;
  }
  
  .indicators-grid {
    grid-template-columns: 1fr;
  }
}

/* Dashboard Body */
.dashboard-body {
  display: flex;
  flex: 1 1;
}

/* Menu Lateral */
.sidebar {
  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);
  border-right: 2px solid #636e72;
  transition: all 0.3s ease;
  height: calc(100vh - 75px);
  overflow-y: auto;
  position: sticky;
  top: 0;
}

.sidebar.open {
  width: 250px;
}

.sidebar.closed {
  width: 60px;
}

.sidebar-header {
  padding: 1rem;
  border-bottom: 1px solid rgba(99, 110, 114, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-header h3 {
  color: #495057;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 1px;
}

.sidebar-toggle {
  background: none;
  border: 1px solid #636e72;
  color: #495057;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.3s ease;
}

.sidebar-toggle:hover {
  background: rgba(255, 215, 0, 0.1);
  border-color: #FFD700;
}

.sidebar-nav {
  padding: 1rem 0;
}

.sidebar-item {
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  color: #495057;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 0.5px;
}

.sidebar-item:hover {
  background: rgba(255, 215, 0, 0.1);
  color: #2d3436;
}

.sidebar-item.active {
  background: #FFD700;
  color: #2d3436;
  font-weight: 600;
  border-right: 3px solid #2d3436;
}

.sidebar.closed .sidebar-item {
  justify-content: center;
  padding: 0.75rem 0.5rem;
}

.sidebar.closed .sidebar-header h3 {
  display: none;
}

.sidebar-divider {
  height: 1px;
  background: rgba(99, 110, 114, 0.3);
  margin: 0.5rem 1rem;
}

.sidebar.closed .sidebar-divider {
  margin: 0.5rem;
}

/* Ajuste no Main Content */
.dashboard-main {
  flex: 1 1;
  padding: 2rem;
  overflow-y: auto;
  background: #2d3436;
}

.config-panel {
  background: rgba(248, 249, 250, 0.1);
  border-radius: 12px;
  padding: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.config-panel h2 {
  color: #FFD700;
  margin-bottom: 1rem;
}

.config-panel p {
  color: #ccc;
}

.system-status {
  color: #28a745;
  font-weight: 600;
  font-size: 0.9rem;
}

/* Submenu Styles */
.submenu-arrow {
  margin-left: auto;
  transition: transform 0.3s ease;
  font-size: 0.8rem;
}

.submenu-arrow.open {
  transform: rotate(180deg);
}

.submenu {
  margin-left: 1rem;
  border-left: 2px solid #495057;
  padding-left: 0.5rem;
}

.submenu-item {
  width: 100%;
  padding: 0.5rem 0.75rem;
  background: none;
  border: none;
  color: #6c757d;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 0.5px;
}

.submenu-item:hover {
  color: #FFD700;
  background: rgba(255, 215, 0, 0.1);
}

.submenu-item.active {
  color: #FFD700;
  background: rgba(255, 215, 0, 0.15);
  border-left: 3px solid #FFD700;
}

/* Submenu Main Info Styling */
.submenu-main-info {
  width: 100%;
  text-align: left;
}

.submenu-main-title {
  font-weight: 600;
  color: #ffffff;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.submenu-turbine-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(108, 117, 125, 0.3);
}

.submenu-turbine-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0;
  font-size: 0.7rem;
  gap: 0.5rem;
}

.turbine-id {
  font-weight: 700;
  color: #FFD700;
  min-width: 70px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.turbine-model {
  color: #adb5bd;
  font-size: 0.65rem;
  flex: 1 1;
}

.connection-type {
  color: #6c757d;
  font-size: 0.6rem;
  font-style: italic;
  text-align: right;
  min-width: 80px;
}

.turbine-power {
  color: #28a745;
  font-weight: 600;
  min-width: 50px;
  text-align: right;
}

.turbine-wind {
  color: #17a2b8;
  font-weight: 500;
  min-width: 45px;
  text-align: right;
}

.status-dot {
  font-size: 0.6rem;
  margin-left: auto;
}

.status-dot.operational {
  color: #28a745;
}

.status-dot.warning {
  color: #ffc107;
}

.status-dot.maintenance {
  color: #6c757d;
}

.status-dot.inactive {
  color: #dc3545;
}

/* Enhanced submenu item for complex content */
.submenu-item:has(.submenu-main-info) {
  padding: 0.75rem;
  min-height: auto;
}

.submenu-item:has(.submenu-main-info):hover {
  background: rgba(255, 215, 0, 0.1);
  border-left: 3px solid #FFD700;
}

.submenu-item:has(.submenu-main-info).active {
  background: rgba(255, 215, 0, 0.15);
  border-left: 3px solid #FFD700;
}

/* OPC UA Servers Grid */
.opcua-servers-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.server-info-card {
  background: rgba(40, 44, 52, 0.9);
  border: 1px solid rgba(108, 117, 125, 0.3);
  border-radius: 8px;
  padding: 1.5rem;
}

.server-info-card h4 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 600;
}

.connection-status.active {
  color: #28a745;
  font-weight: 600;
}

.connection-status.inactive {
  color: #dc3545;
  font-weight: 600;
}

/* Single Column Simulator Layout */
.simulator-single-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  width: 100%;
}

.simulator-single-layout .simulator-card {
  background: rgba(40, 44, 52, 0.9);
  border: 1px solid rgba(108, 117, 125, 0.3);
  border-radius: 8px;
  padding: 1.5rem;
}

/* Responsive adjustments */
@media (max-width: 1400px) {
  .opcua-servers-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .simulator-single-layout {
    gap: 1rem;
  }
}

/* Form Styles */
.config-form {
  margin-top: 1.5rem;
}

.form-section {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-section h3 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.1rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  color: #ccc;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 500;
}

.form-group input,
.form-group select {
  padding: 0.75rem;
  border: 1px solid #495057;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #FFD700;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
}

.form-group input::placeholder {
  color: #6c757d;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
}

.btn-primary {
  background: linear-gradient(145deg, #FFD700, #FFA500);
  color: #2d3436;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: linear-gradient(145deg, #FFA500, #FFD700);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}

.btn-secondary {
  background: rgba(108, 117, 125, 0.2);
  color: #ccc;
  border: 1px solid #6c757d;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: rgba(108, 117, 125, 0.3);
  color: #fff;
  border-color: #adb5bd;
}

/* Estilos para Parques */
.parques-list {
  margin-top: 1rem;
}

.parque-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.parque-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #FFD700;
}

.parque-info h4 {
  color: #FFD700;
  margin-bottom: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.parque-info p {
  color: #ccc;
  margin: 0.25rem 0;
  font-size: 0.9rem;
}

.parque-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

/* Botões pequenos */
.btn-small {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  border-radius: 4px;
}

.btn-danger {
  background: linear-gradient(145deg, #dc3545, #c82333);
  color: white;
  border: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-danger:hover {
  background: linear-gradient(145deg, #c82333, #dc3545);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* Grid de Aerogeradores */
.aerogeradores-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.aerogerador-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.3s ease;
}

.aerogerador-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #FFD700;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.card-header h5 {
  color: #FFD700;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.1rem;
}

.status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Aerogerador SVG animado */
.turbine-icon {
  width: 20px;
  height: 20px;
  display: block;
  margin: 0 auto;
}

/* Animação maior na tela inicial */
.park-card .turbine-icon {
  width: 40px;
  height: 40px;
}

.park-card .turbine-rotor {
  transform-origin: 12px 8px;
}

.turbine-rotor {
  transform-origin: 12px 8px;
  animation: spin 2s linear infinite;
}

.turbine-rotor.operational {
  animation-duration: 1.5s;
}

.turbine-rotor.maintenance {
  animation-duration: 4s;
}

.turbine-rotor.warning {
  animation-duration: 3s;
}

.turbine-rotor.inactive {
  animation: none;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.turbine-tower.operational {
  stroke: #28a745;
  fill: #28a745;
}

.turbine-blades.operational {
  stroke: #28a745;
  fill: #28a745;
}

.turbine-tower.maintenance {
  stroke: #ffc107;
  fill: #ffc107;
}

.turbine-blades.maintenance {
  stroke: #ffc107;
  fill: #ffc107;
}

.turbine-tower.warning {
  stroke: #ff6b35;
  fill: #ff6b35;
}

.turbine-blades.warning {
  stroke: #ff6b35;
  fill: #ff6b35;
}

.turbine-tower.inactive {
  stroke: #dc3545;
  fill: #dc3545;
}

.turbine-blades.inactive {
  stroke: #dc3545;
  fill: #dc3545;
}

.card-content p {
  color: #ccc;
  margin: 0.25rem 0;
  font-size: 0.85rem;
}

.card-actions {
  margin-top: 0.75rem;
  display: flex;
  gap: 0.5rem;
}

.aerogerador-form {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.aerogerador-form h4 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Tabela de Aerogeradores */
.aerogeradores-table {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #495057;
}

.table-header {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1.5fr 1fr 1fr 1.5fr;
  background: rgba(255, 215, 0, 0.1);
  border-bottom: 2px solid #FFD700;
  font-weight: 600;
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

.table-header > div {
  padding: 1rem;
  text-align: center;
}

.table-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1.5fr 1fr 1fr 1.5fr;
  border-bottom: 1px solid #495057;
  transition: all 0.3s ease;
}

.table-row:hover {
  background: rgba(255, 255, 255, 0.05);
}

.table-row > div {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.table-row > div:last-child {
  gap: 0.5rem;
}

/* Dashboard de Projetos */
.projects-overview {
  margin-bottom: 2rem;
}

.project-summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.summary-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
}

.summary-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #FFD700;
  transform: translateY(-2px);
}

.summary-card h3 {
  color: #FFD700;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  text-align: center;
}

/* Parques Dashboard */
.parks-dashboard h3 {
  color: #FFD700;
  margin-bottom: 1.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.3rem;
}

.park-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.park-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.3s ease;
  min-width: 0;
}

.park-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #FFD700;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.park-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #495057;
  padding-bottom: 0.5rem;
}

.park-header h4 {
  color: #FFD700;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.95rem;
}

.park-code {
  background: rgba(255, 215, 0, 0.2);
  color: #FFD700;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.park-info {
  margin-bottom: 1rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.3rem;
  color: #ccc;
  font-size: 0.85rem;
  font-size: 0.9rem;
}

.info-row span:first-child {
  font-weight: 600;
  color: #adb5bd;
}

/* Turbinas Grid */
.turbines-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}

.turbine-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #495057;
  border-radius: 4px;
  padding: 0.5rem;
  transition: all 0.3s ease;
}

.turbine-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: #6c757d;
}

.turbine-id {
  color: #FFD700;
  font-weight: 600;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 0.25rem;
}

.turbine-model {
  color: #adb5bd;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.turbine-status {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.5rem;
}

.power-output {
  color: #28a745;
  font-weight: 600;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Condições Ambientais */
.environmental-conditions {
  margin-bottom: 2rem;
}

.environmental-conditions h3 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.2rem;
}

.conditions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.condition-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  transition: all 0.3s ease;
}

.condition-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #6c757d;
}

.condition-card h4 {
  color: #adb5bd;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Alertas */
.alerts-section h3 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.2rem;
}

.alerts-list .alert-item {
  display: grid;
  grid-template-columns: 80px 1fr 150px;
  gap: 1rem;
  align-items: center;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #495057;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  transition: all 0.3s ease;
}

.alerts-list .alert-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: #6c757d;
}

.alert-park {
  color: #6c757d;
  font-size: 0.8rem;
  font-style: italic;
  text-align: right;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.alert-item.info {
  border-left: 4px solid #17a2b8;
}

.alert-item.info .alert-time {
  color: #17a2b8;
}

/* Complexos Dashboard */
.complexes-dashboard h3 {
  color: #FFD700;
  margin-bottom: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.4rem;
}

.complex-card {
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid #495057;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  transition: all 0.3s ease;
}

.complex-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #FFD700;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.complex-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #FFD700;
  padding-bottom: 1rem;
}

.complex-header h4 {
  color: #FFD700;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
}

.complex-code {
  background: linear-gradient(145deg, #FFD700, #FFA500);
  color: #2d3436;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
}

.complex-info {
  margin-bottom: 2rem;
}

.parks-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.park-header h5 {
  color: #FFD700;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

.park-summary {
  color: #adb5bd;
  font-size: 0.85rem;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Tree Structure */
.complexes-tree {
  margin-top: 1rem;
}

.complex-tree-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
}

.complex-tree-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #FFD700;
}

.complex-tree-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.complex-tree-header h4 {
  color: #FFD700;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.1rem;
}

.complex-tree-info {
  margin-bottom: 1rem;
  color: #ccc;
  font-size: 0.9rem;
}

.parks-tree {
  margin-left: 2rem;
  border-left: 2px solid #495057;
  padding-left: 1rem;
  margin-bottom: 1rem;
}

.park-tree-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #6c757d;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  transition: all 0.3s ease;
}

.park-tree-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: #adb5bd;
}

.park-tree-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.park-tree-header h5 {
  color: #adb5bd;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

.tree-code {
  background: rgba(255, 215, 0, 0.15);
  color: #FFD700;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.tree-actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.75rem;
}

/* Turbinas Clicáveis */
.turbine-item.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
}

.turbine-item.clickable:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #FFD700;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);
}

/* Tela de Detalhes do Aerogerador */
.turbine-details-panel {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.details-header {
  margin-bottom: 2rem;
}

.back-navigation {
  margin-bottom: 1rem;
}

.btn-back {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #495057;
  color: #adb5bd;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: #FFD700;
  color: #FFD700;
  transform: translateX(-2px);
}

.details-header h2 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
}

.turbine-summary {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.turbine-model {
  background: rgba(255, 255, 255, 0.1);
  color: #adb5bd;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

/* Métricas Operacionais */
.operational-metrics {
  margin-bottom: 2rem;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.metric-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.metric-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #6c757d;
}

.metric-card.primary {
  border-color: #FFD700;
  background: rgba(255, 215, 0, 0.05);
}

.metric-card.primary:hover {
  background: rgba(255, 215, 0, 0.1);
  border-color: #FFD700;
}

.metric-card h3 {
  color: #adb5bd;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.metric-display.large .metric-value {
  font-size: 3rem;
  color: #FFD700;
}

.metric-display.large .metric-unit {
  font-size: 1.2rem;
}

.metric-percentage {
  color: #28a745;
  font-size: 0.85rem;
  margin-top: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.metric-trend {
  font-size: 0.8rem;
  margin-top: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.metric-trend.positive {
  color: #28a745;
}

.metric-trend.stable {
  color: #ffc107;
}

.metric-trend.negative {
  color: #dc3545;
}

/* Parâmetros Técnicos */
.technical-parameters {
  margin-bottom: 2rem;
}

.technical-parameters h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
}

.parameters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
}

.parameter-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1.5rem;
}

.parameter-section h4 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #495057;
  padding-bottom: 0.5rem;
}

.parameter-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.parameter-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.param-label {
  color: #adb5bd;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.param-value {
  font-weight: 600;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.param-value.good {
  color: #28a745;
}

.param-value.warning {
  color: #ffc107;
}

.param-value.critical {
  color: #dc3545;
}

/* Painel de Controle */
.control-panel {
  margin-bottom: 2rem;
}

.control-panel h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
}

.controls-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.control-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1.5rem;
}

.control-section h4 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.control-buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.control-btn {
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.control-btn.start {
  background: linear-gradient(145deg, #28a745, #20c997);
  color: white;
}

.control-btn.start:hover {
  background: linear-gradient(145deg, #20c997, #28a745);
  transform: translateY(-2px);
}

.control-btn.stop {
  background: linear-gradient(145deg, #dc3545, #fd7e14);
  color: white;
}

.control-btn.stop:hover {
  background: linear-gradient(145deg, #fd7e14, #dc3545);
  transform: translateY(-2px);
}

.control-btn.maintenance {
  background: linear-gradient(145deg, #ffc107, #fd7e14);
  color: #2d3436;
}

.control-btn.maintenance:hover {
  background: linear-gradient(145deg, #fd7e14, #ffc107);
  transform: translateY(-2px);
}

.control-btn.reset {
  background: linear-gradient(145deg, #6c757d, #adb5bd);
  color: white;
}

.control-btn.reset:hover {
  background: linear-gradient(145deg, #adb5bd, #6c757d);
  transform: translateY(-2px);
}

.control-settings {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.setting-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.setting-item label {
  color: #adb5bd;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.setting-item input[type="range"] {
  width: 100%;
}

.setting-item select {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #495057;
  color: #fff;
  padding: 0.5rem;
  border-radius: 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Log de Eventos */
.events-log {
  margin-bottom: 2rem;
}

.events-log h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
}

.events-list {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1rem;
  max-height: 300px;
  overflow-y: auto;
}

.event-item {
  display: grid;
  grid-template-columns: 80px 1fr 120px;
  gap: 1rem;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.event-item:last-child {
  border-bottom: none;
}

.event-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.event-time {
  color: #6c757d;
  font-size: 0.8rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.event-message {
  color: #ccc;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.event-type {
  color: #adb5bd;
  font-size: 0.8rem;
  text-align: right;
  font-style: italic;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.event-item.warning .event-time {
  color: #ffc107;
}

.event-item.warning .event-message {
  color: #ffc107;
}

/* Indicador de última atualização */
.metric-info {
  margin-top: 0.5rem;
}

.metric-info small {
  color: #6c757d;
  font-size: 0.75rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Status badge para warning */
.status-badge.warning {
  background: linear-gradient(145deg, #ffc107, #fd7e14);
  color: #2d3436;
  animation: pulse-warning 2s infinite;
}

@keyframes pulse-warning {
  0%, 100% {
    box-shadow: 0 0 8px rgba(255, 193, 7, 0.4);
  }
  50% {
    box-shadow: 0 0 16px rgba(255, 193, 7, 0.8);
  }
}

/* Botões desabilitados */
.control-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* Seção Curva de Potência */
.power-curve-section {
  margin-bottom: 2rem;
}

.power-curve-section h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
}

.chart-container {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1.5rem;
}

.chart-header {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #495057;
}

.current-point {
  color: #adb5bd;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

.current-point strong {
  color: #FFD700;
}

.curve-specs {
  display: flex;
  gap: 1.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
}

.spec-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.spec-label {
  color: #6c757d;
  font-size: 0.75rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.spec-value {
  color: #28a745;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.power-curve-chart {
  width: 100%;
  height: 400px;
}

.curve-svg {
  width: 100%;
  height: 100%;
}

/* Seção Histórico Diário */
.daily-history-section {
  margin-bottom: 2rem;
}

.daily-history-section h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
}

.history-container {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1.5rem;
}

.history-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #495057;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-label {
  color: #adb5bd;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  text-align: center;
}

.summary-value {
  color: #FFD700;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  text-align: center;
}

.history-chart {
  width: 100%;
  height: 300px;
  margin-bottom: 2rem;
}

.history-svg {
  width: 100%;
  height: 100%;
}

.history-table {
  overflow-x: auto;
}

.history-table table {
  width: 100%;
  border-collapse: collapse;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.history-table th,
.history-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.history-table th {
  color: #FFD700;
  font-weight: 600;
  background: rgba(255, 215, 0, 0.05);
}

.history-table td {
  color: #adb5bd;
}

.history-table tr.maintenance-day {
  background: rgba(220, 53, 69, 0.05);
}

.availability-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}

.availability-badge.good {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
}

.availability-badge.low {
  background: rgba(220, 53, 69, 0.2);
  color: #dc3545;
}

/* Responsividade para gráficos */
@media (max-width: 768px) {
  .chart-container,
  .history-container {
    padding: 1rem;
  }
  
  .power-curve-chart {
    height: 300px;
  }
  
  .history-chart {
    height: 250px;
  }
  
  .history-summary {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* Centro de Operações - Monitoramento Operacional */
.operational-dashboard {
  padding: 2rem;
  max-width: 100%;
  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);
  min-height: 100vh;
}

.operational-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #FFD700;
}

.operational-header h2 {
  color: #FFD700;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.operational-controls {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

/* Painel de Status Crítico - Compacto */
.critical-status-panel {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #636e72;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.critical-status-panel h3 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.status-overview-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
}

.status-metric {
  background: linear-gradient(145deg, #495057 0%, #6c757d 100%);
  border-radius: 6px;
  padding: 0.75rem;
  text-align: center;
  border: 1px solid #636e72;
  transition: all 0.3s ease;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.status-metric:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(255, 215, 0, 0.2);
}

.metric-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  margin-bottom: 0.5rem;
}

.metric-header h4 {
  color: #ffffff;
  margin: 0;
  font-size: 0.75rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 500;
}

.capacity-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #17a2b8;
  box-shadow: 0 0 6px #17a2b8;
  animation: pulse 2s infinite;
}

.metric-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin: 0.25rem 0;
  line-height: 1;
}

.metric-subtitle {
  color: #adb5bd;
  font-size: 0.7rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.9;
}

/* Mapa Visual dos Aerogeradores */
.turbines-visual-map {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #636e72;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.turbines-visual-map h3 {
  color: #FFD700;
  margin-bottom: 2rem;
  font-size: 1.3rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.complexes-operational-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  max-width: 100%;
}

.complex-operational-section {
  background: rgba(73, 80, 87, 0.3);
  border: 1px solid #495057;
  border-radius: 8px;
  padding: 1.5rem;
  min-width: 0;
}

.complex-operational-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.2rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #636e72;
}

.complex-operational-header h4 {
  color: #ffffff;
  margin: 0;
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.complex-stats {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.complex-power {
  color: #28a745;
  font-weight: 700;
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.complex-efficiency {
  color: #adb5bd;
  font-size: 0.8rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.parks-operational-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.park-operational-section {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 215, 0, 0.3);
  border-radius: 6px;
  padding: 1rem;
}

.park-operational-section h5 {
  color: #FFD700;
  margin-bottom: 0.8rem;
  font-size: 0.85rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.turbines-status-visual {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-start;
}

.turbine-visual-indicator {
  position: relative;
  width: 50px;
  height: 60px;
  background: linear-gradient(145deg, #495057 0%, #343a40 100%);
  border: 2px solid #6c757d;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.3rem;
  text-align: center;
}

.turbine-visual-indicator:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
  border-color: #FFD700;
}

.turbine-visual-indicator.operational {
  border-color: #28a745;
  box-shadow: 0 0 10px rgba(40, 167, 69, 0.3);
}

.turbine-visual-indicator.warning {
  border-color: #ffc107;
  box-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
}

.turbine-visual-indicator.maintenance {
  border-color: #6f42c1;
  box-shadow: 0 0 10px rgba(111, 66, 193, 0.3);
}

.turbine-visual-indicator.inactive {
  border-color: #dc3545;
  box-shadow: 0 0 10px rgba(220, 53, 69, 0.3);
}

.turbine-visual-id {
  color: #ffffff;
  font-size: 0.55rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.turbine-visual-power {
  color: #FFD700;
  font-size: 0.5rem;
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.turbine-visual-status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 auto;
  animation: pulse 2s infinite;
}

.turbine-visual-status.operational {
  background: #28a745;
  box-shadow: 0 0 6px #28a745;
}

.turbine-visual-status.warning {
  background: #ffc107;
  box-shadow: 0 0 6px #ffc107;
}

.turbine-visual-status.maintenance {
  background: #6f42c1;
  box-shadow: 0 0 6px #6f42c1;
}

.turbine-visual-status.inactive {
  background: #dc3545;
  box-shadow: 0 0 6px #dc3545;
}

/* Performance Consolidado - Mais Compacto */
.consolidated-performance {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #636e72;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.consolidated-performance h3 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.performance-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.performance-card {
  background: linear-gradient(145deg, #495057 0%, #6c757d 100%);
  border: 1px solid #636e72;
  border-radius: 6px;
  padding: 1rem;
  text-align: center;
  transition: all 0.3s ease;
}

.performance-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);
}

.performance-card h4 {
  color: #ffffff;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.performance-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 0.3rem;
}

.performance-trend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #adb5bd;
  font-size: 0.8rem;
}

.trend-indicator {
  font-weight: 700;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
}

.trend-indicator.positive {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
}

.performance-subtitle {
  color: #adb5bd;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Legenda Operacional - Compacta */
.operational-legend {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #636e72;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.operational-legend h4 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-size: 0.95rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.legend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.8rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #adb5bd;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.turbine-visual-indicator.small {
  width: 30px;
  height: 35px;
  padding: 0.2rem;
  transform: none;
}

.turbine-visual-indicator.small:hover {
  transform: none;
  box-shadow: none;
}

.turbine-visual-indicator.small .turbine-visual-status {
  width: 6px;
  height: 6px;
}

/* Responsividade para centro de operações */
@media (max-width: 768px) {
  .operational-dashboard {
    padding: 0.5rem;
  }
  
  .operational-header {
    margin-bottom: 1rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .complexes-operational-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .complex-operational-section {
    padding: 1rem;
  }
  
  .complex-stats {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }
  
  .status-overview-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }
  
  .status-metric {
    min-height: 70px;
    padding: 0.5rem;
  }
  
  .metric-value {
    font-size: 1.4rem;
  }
  
  .metric-subtitle {
    font-size: 0.65rem;
  }
  
  .performance-metrics-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 0.5rem;
  }
  
  .parks-operational-container {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .turbines-status-visual {
    justify-content: center;
    gap: 0.3rem;
  }
  
  .turbine-visual-indicator {
    width: 40px;
    height: 50px;
  }
  
  .turbine-visual-id {
    font-size: 0.45rem;
  }
  
  .turbine-visual-power {
    font-size: 0.4rem;
  }
}

/* Novos elementos para o complexo único */
.more-turbines {
  background: rgba(108, 117, 125, 0.3) !important;
  border: 2px dashed rgba(108, 117, 125, 0.6) !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  cursor: default;
}

.more-count {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.more-text {
  font-size: 0.75rem;
  opacity: 0.8;
}

.more-parks-indicator {
  grid-column: 1 / -1;
  margin-top: 1rem;
}

.more-parks-card {
  background: linear-gradient(145deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 215, 0, 0.05) 100%);
  border: 2px solid rgba(255, 215, 0, 0.3);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
}

.more-parks-card:hover {
  background: linear-gradient(145deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 215, 0, 0.08) 100%);
  border-color: rgba(255, 215, 0, 0.5);
  transform: translateY(-2px);
}

.more-parks-card h5 {
  color: #FFD700;
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.more-parks-card p {
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 1rem 0;
  font-size: 0.9rem;
}

.view-all-btn {
  background: linear-gradient(145deg, #636e72 0%, #2d3436 100%);
  border: 2px solid #FFD700;
  color: #FFD700;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 1px;
}

.view-all-btn:hover {
  background: linear-gradient(145deg, #FFD700 0%, #ffc107 100%);
  color: #2d3436;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);
}

.complex-location {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  margin-left: 1rem;
}

/* Indicador de atualização em tempo real */
.update-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #495057;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.update-pulse {
  width: 8px;
  height: 8px;
  background: #28a745;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.system-status {
  color: #28a745;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  background: rgba(40, 167, 69, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

/* Indicador de alarme */
.alarm-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #dc3545;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  background: rgba(220, 53, 69, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(220, 53, 69, 0.3);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.alarm-status.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
}

.alarm-status.clickable:hover {
  background: rgba(220, 53, 69, 0.2);
  border-color: rgba(220, 53, 69, 0.5);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.alarm-indicator {
  width: 8px;
  height: 8px;
  background: #dc3545;
  border-radius: 50%;
  animation: alarmBlink 1s infinite;
}

@keyframes alarmBlink {
  0%, 50% {
    opacity: 1;
    transform: scale(1);
    box-shadow: 0 0 8px #dc3545;
  }
  51%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
    box-shadow: 0 0 4px #dc3545;
  }
}

/* Indicador de status HTTP */
.http-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  transition: all 0.3s ease;
}

.http-status.available {
  color: #28a745;
  background: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.http-status.unavailable {
  color: #ffc107;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-dot.online {
  background: #28a745;
  box-shadow: 0 0 6px #28a745;
  animation: pulse 2s infinite;
}

.status-dot.offline {
  background: #ffc107;
  box-shadow: 0 0 6px #ffc107;
  animation: statusBlink 1.5s infinite;
}

@keyframes statusBlink {
  0%, 70% {
    opacity: 1;
  }
  71%, 100% {
    opacity: 0.4;
  }
}

/* Botão de teste de alarme */
.test-alarm-btn {
  background: linear-gradient(145deg, #6f42c1 0%, #563d7c 100%);
  border: 2px solid #6f42c1;
  color: #ffffff;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.test-alarm-btn:hover {
  background: linear-gradient(145deg, #563d7c 0%, #6f42c1 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(111, 66, 193, 0.4);
}

/* Botão de teste de popup */
.test-popup-btn {
  background: linear-gradient(145deg, #dc3545 0%, #a71e2a 100%);
  border: 2px solid #dc3545;
  color: #ffffff;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.test-popup-btn:hover {
  background: linear-gradient(145deg, #a71e2a 0%, #dc3545 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

/* Notificação de Falha/Manutenção */
.failure-notification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-out;
}

.failure-notification-modal {
  background: linear-gradient(145deg, #2a2a2a 0%, #1e1e1e 100%);
  border: 2px solid #555;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  animation: slideIn 0.4s ease-out;
}

.notification-header {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 2px solid #444;
  position: relative;
}

.notification-header.failure {
  background: linear-gradient(145deg, #dc3545 0%, #a71e2a 100%);
  border-bottom-color: #a71e2a;
}

.notification-timer {
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Overlay para múltiplas notificações */
.failure-notifications-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(4px);
  padding: 2rem;
}

/* Grade de notificações */
.failure-notifications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  max-width: 1400px;
  max-height: 90vh;
  overflow-y: auto;
  width: 100%;
}

/* Responsividade para múltiplos popups */
@media (max-width: 1200px) {
  .failure-notifications-grid {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .failure-notifications-grid {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
  
  .failure-notifications-overlay {
    padding: 1rem;
  }
}

/* Estilos para o Emulador OPC UA */
.turbines-panel {
  padding: 2rem;
  background: #f8f9fa;
  min-height: calc(100vh - 80px);
}

.opcua-emulator {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.emulator-header {
  background: linear-gradient(135deg, #2d3436 0%, #636e72 100%);
  color: white;
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.emulator-header h3 {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.4rem;
  font-weight: 600;
}

.server-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #28a745;
  animation: pulse 2s infinite;
}

.status-indicator.running {
  background: #28a745;
  animation: pulse 2s infinite;
}

.status-indicator.stopped {
  background: #dc3545;
  animation: none;
}

.status-indicator.transitioning {
  background: #ffc107;
  animation: blink 1s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0.5;
  }
}

.emulator-content {
  padding: 2rem;
}

.connection-info {
  margin-bottom: 2rem;
}

.connection-info h4 {
  color: #2d3436;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.connection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.connection-item {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #FFD700;
}

.connection-item label {
  display: block;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.connection-value {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  color: #2d3436;
  font-weight: 500;
  word-break: break-all;
}

.variables-section {
  margin-bottom: 2rem;
}

.variables-section h4 {
  color: #2d3436;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.variables-table {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 3fr 1fr 1.5fr 1fr;
  background: #495057;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
}

.table-header span,
.table-row span {
  padding: 1rem 0.75rem;
  border-right: 1px solid #dee2e6;
}

.table-header span:last-child,
.table-row span:last-child {
  border-right: none;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 3fr 1fr 1.5fr 1fr;
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background: #f8f9fa;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row span:nth-child(2) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.85rem;
  color: #6c757d;
}

.table-row span:nth-child(4) {
  font-weight: 600;
  color: #28a745;
}

.emulator-controls h4 {
  color: #2d3436;
  margin-bottom: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.controls-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.controls-grid .btn-primary,
.controls-grid .btn-secondary {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.controls-grid .btn-primary {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.controls-grid .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.controls-grid .btn-secondary {
  background: #6c757d;
  color: white;
}

.controls-grid .btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
}

.controls-grid .btn-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.controls-grid .btn-success:hover {
  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);
  transform: translateY(-2px);
}

.controls-grid button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.controls-grid button:disabled:hover {
  transform: none !important;
}

.emulator-info {
  background: #e3f2fd;
  border-left: 4px solid #2196f3;
  padding: 1rem;
  border-radius: 4px;
}

.emulator-info p {
  margin: 0.5rem 0;
  color: #1565c0;
  font-size: 0.9rem;
}

.emulator-info p:first-child {
  margin-top: 0;
}

.emulator-info p:last-child {
  margin-bottom: 0;
}

/* Responsividade para o emulador */
@media (max-width: 768px) {
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
  
  .table-header span,
  .table-row span {
    border-right: none;
    border-bottom: 1px solid #dee2e6;
    padding: 0.5rem 0.75rem;
  }
  
  .table-header span:before,
  .table-row span:before {
    content: attr(data-label) ": ";
    font-weight: 600;
    display: inline-block;
    width: 120px;
  }
  
  .connection-grid {
    grid-template-columns: 1fr;
  }
  
  .controls-grid {
    grid-template-columns: 1fr;
  }
}

.notification-icon {
  font-size: 3rem;
  margin-right: 1rem;
  animation: pulse 2s infinite;
}

.notification-title h3 {
  margin: 0;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.notification-title p {
  margin: 0.5rem 0 0 0;
  color: #f0f0f0;
  font-size: 1.1rem;
  font-weight: 600;
}

.notification-content {
  padding: 1.5rem;
}

.turbine-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-left: 3px solid #6c757d;
  border-radius: 6px;
}

.detail-label {
  font-weight: 600;
  color: #adb5bd;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

.detail-value {
  font-weight: 700;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1rem;
}

.detail-value.status-inactive {
  color: #dc3545;
  text-shadow: 0 0 8px rgba(220, 53, 69, 0.5);
}

.detail-value.status-maintenance {
  color: #ff6b35;
  text-shadow: 0 0 8px rgba(255, 107, 53, 0.5);
}

.detail-value.status-operational {
  color: #28a745;
  text-shadow: 0 0 8px rgba(40, 167, 69, 0.5);
}

.notification-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-acknowledge {
  background: linear-gradient(145deg, #28a745 0%, #1e7e34 100%);
  border: 2px solid #28a745;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  min-width: 120px;
}

.btn-acknowledge:hover {
  background: linear-gradient(145deg, #1e7e34 0%, #28a745 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(40, 167, 69, 0.4);
}

.btn-details {
  background: linear-gradient(145deg, #007bff 0%, #0056b3 100%);
  border: 2px solid #007bff;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  min-width: 120px;
}

.btn-details:hover {
  background: linear-gradient(145deg, #0056b3 0%, #007bff 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 123, 255, 0.4);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-50px) scale(0.9);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Responsividade para mobile */
@media (max-width: 768px) {
  .failure-notification-modal {
    width: 95%;
    margin: 1rem;
  }
  
  .turbine-details-grid {
    grid-template-columns: 1fr;
  }
  
  .notification-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .btn-acknowledge,
  .btn-details {
    width: 100%;
    max-width: 200px;
  }
}



/* Turbine Simulator Styles */
.turbine-simulator-panel {
  padding: 15px;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  min-height: 100vh;
  color: #ecf0f1;
}

.turbine-simulator-panel h2 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
  font-size: 1.6rem;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.3);
}

/* Interface de Configuração de Aerogerador OPC UA */
.turbine-config-panel {
  padding: 30px;
  background: linear-gradient(135deg, #2a2a2a 0%, #383838 100%);
  border-radius: 15px;
  color: #ffffff;
  min-height: 100vh;
}

.turbine-config-panel h2 {
  color: #FFD700;
  margin-bottom: 30px;
  font-size: 1.8rem;
  text-align: center;
  border-bottom: 2px solid #FFD700;
  padding-bottom: 15px;
}

.turbine-config-panel .form-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 25px;
}

.turbine-config-panel .form-section h3 {
  color: #FFD700;
  margin-bottom: 20px;
  font-size: 1.3rem;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
  padding-bottom: 10px;
}

.turbine-config-panel .form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.turbine-config-panel .form-group {
  display: flex;
  flex-direction: column;
}

.turbine-config-panel .form-group label {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.turbine-config-panel .form-group input,
.turbine-config-panel .form-group select {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px 15px;
  color: #ffffff;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.turbine-config-panel .form-group input:focus,
.turbine-config-panel .form-group select:focus {
  border-color: #FFD700;
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
}

.turbine-config-panel .form-group input:disabled {
  background: rgba(0, 0, 0, 0.2);
  color: #888;
  cursor: not-allowed;
}

.turbine-config-panel .url-preview {
  background: rgba(255, 215, 0, 0.1) !important;
  border-color: rgba(255, 215, 0, 0.5) !important;
  color: #FFD700 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.auth-toggle {
  margin-bottom: 20px;
}

.switch-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
  color: #ffffff;
}

.switch-label input[type="checkbox"] {
  margin-right: 12px;
  transform: scale(1.2);
}

.auth-fields {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.status-message {
  padding: 12px 20px;
  border-radius: 8px;
  margin: 20px 0;
  font-weight: 600;
}

.status-message.success {
  background: rgba(76, 175, 80, 0.2);
  border: 1px solid #4CAF50;
  color: #4CAF50;
}

.status-message.error {
  background: rgba(244, 67, 54, 0.2);
  border: 1px solid #f44336;
  color: #f44336;
}

.form-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;
}

.btn-test {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-test:hover:not(:disabled) {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
  transform: translateY(-2px);
}

.btn-test:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.configured-turbines {
  margin-top: 40px;
}

.configured-turbines h3 {
  color: #FFD700;
  margin-bottom: 20px;
  font-size: 1.3rem;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
  padding-bottom: 10px;
}

.turbines-list {
  display: grid;
  gap: 20px;
}

.turbine-config-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.turbine-info h4 {
  color: #FFD700;
  margin-bottom: 10px;
  font-size: 1.1rem;
}

.turbine-info p {
  margin: 5px 0;
  color: #cccccc;
  font-size: 0.9rem;
}

.turbine-actions {
  display: flex;
  gap: 10px;
}

.btn-small {
  padding: 8px 15px;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-small.btn-danger {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
  color: white;
}

.btn-small.btn-danger:hover {
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
  transform: translateY(-1px);
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .turbine-config-panel {
    padding: 20px 15px;
  }

  .turbine-config-panel .form-grid {
    grid-template-columns: 1fr;
  }

  .form-actions {
    flex-direction: column;
  }

  .turbine-config-item {
    flex-direction: column;
    gap: 15px;
  }

  .turbine-actions {
    align-self: stretch;
  }
}

.simulator-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  max-width: 1000px;
  margin: 0 auto;
}

/* Virtual Turbine Control */
.virtual-turbine-control {
  background: rgba(248, 249, 250, 0.05);
  border-radius: 8px;
  padding: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.virtual-turbine-control h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 12px;
  font-size: 1.2rem;
}

.turbine-status-overview {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.status-indicator-large {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-led-large {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 8px currentColor;
}

.status-led-large.operational {
  background: #28a745;
  box-shadow: 0 0 15px #28a745;
}

.status-led-large.warning {
  background: #ffc107;
  box-shadow: 0 0 15px #ffc107;
}

.status-led-large.maintenance {
  background: #17a2b8;
  box-shadow: 0 0 15px #17a2b8;
}

.status-led-large.inactive {
  background: #dc3545;
  box-shadow: 0 0 15px #dc3545;
}

.status-text {
  font-weight: bold;
  font-size: 0.95rem;
}

.quick-metrics {
  display: flex;
  gap: 10px;
}

.metric-card {
  background: rgba(255, 255, 255, 0.05);
  padding: 8px 12px;
  border-radius: 4px;
  text-align: center;
  min-width: 70px;
}

.metric-card label {
  display: block;
  font-size: 0.85rem;
  color: #adb5bd;
  margin-bottom: 5px;
}

.metric-card span {
  font-weight: bold;
  color: #FFD700;
  font-size: 1rem;
}

/* Manual Controls */
.manual-controls h4 {
  color: #FFD700;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
  padding-bottom: 3px;
  font-size: 1rem;
}

.manual-controls .controls-grid {
  display: grid;
  gap: 12px;
}

.control-group {
  display: grid;
  grid-template-columns: 1fr 2fr auto;
  align-items: center;
  gap: 10px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 4px;
}

.control-group label {
  font-weight: 500;
  color: #ecf0f1;
}

.control-group input[type="range"] {
  background: #495057;
  height: 8px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
}

.control-group input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #FFD700;
  cursor: pointer;
  box-shadow: 0 0 8px rgba(255, 215, 0, 0.5);
}

.control-group select {
  background: #495057;
  color: #ecf0f1;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 8px 12px;
  outline: none;
}

.control-group span {
  color: #FFD700;
  font-weight: bold;
  min-width: 60px;
  text-align: right;
}

/* Fault Simulation */
.fault-simulation {
  background: rgba(248, 249, 250, 0.05);
  border-radius: 8px;
  padding: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.fault-simulation h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin-bottom: 12px;
  font-size: 1.2rem;
}

.fault-simulation h4 {
  color: #FFD700;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
  padding-bottom: 3px;
  font-size: 1rem;
}

.fault-form {
  display: grid;
  grid-template-columns: 2fr 1fr auto;
  gap: 10px;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.fault-form select {
  background: #495057;
  color: #ecf0f1;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 8px;
  outline: none;
  font-size: 0.9rem;
}

.faults-list {
  max-height: 250px;
  overflow-y: auto;
  margin-bottom: 15px;
}

.fault-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 6px;
  border-radius: 4px;
  border-left: 3px solid;
}

.fault-item.low {
  background: rgba(40, 167, 69, 0.1);
  border-left-color: #28a745;
}

.fault-item.medium {
  background: rgba(255, 193, 7, 0.1);
  border-left-color: #ffc107;
}

.fault-item.high {
  background: rgba(255, 108, 75, 0.1);
  border-left-color: #ff6c4b;
}

.fault-item.critical {
  background: rgba(220, 53, 69, 0.1);
  border-left-color: #dc3545;
}

.fault-info strong {
  color: #FFD700;
  display: block;
  margin-bottom: 3px;
}

.fault-desc {
  color: #adb5bd;
  font-size: 0.9rem;
  display: block;
  margin-bottom: 5px;
}

.fault-time {
  color: #6c757d;
  font-size: 0.8rem;
}

.fault-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.severity-badge {
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 0.7rem;
  font-weight: bold;
}

.severity-badge.low {
  background: #28a745;
  color: white;
}

.severity-badge.medium {
  background: #ffc107;
  color: #212529;
}

.severity-badge.high {
  background: #ff6c4b;
  color: white;
}

.severity-badge.critical {
  background: #dc3545;
  color: white;
}

.no-faults {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-size: 0.9rem;
}

/* OPC UA Integration */
.opcua-integration {
  background: rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 6px;
  text-align: center;
}

.integration-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 10px 0;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.status-indicator.running {
  background: #28a745;
  box-shadow: 0 0 8px #28a745;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .simulator-layout {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .fault-form {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .turbine-simulator-panel {
    padding: 10px;
  }
}


/* Simulator Card Compact Styles */
.simulator-card {
  background: rgba(248, 249, 250, 0.05);
  border-radius: 8px;
  padding: 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
}

.card-header h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  margin: 0;
  font-size: 1.2rem;
}

.status-indicator-compact {
  display: flex;
  align-items: center;
  gap: 8px;
}

.quick-metrics-compact {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.controls-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.controls-column {
  background: rgba(0, 0, 0, 0.1);
  padding: 15px;
  border-radius: 6px;
}

.controls-column h4 {
  color: #FFD700;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
  padding-bottom: 3px;
  font-size: 1rem;
}

.controls-column h5 {
  color: #FFD700;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.controls-grid-compact {
  display: grid;
  gap: 10px;
}

.fault-form-compact {
  display: grid;
  grid-template-columns: 1fr 80px auto;
  gap: 8px;
  margin-bottom: 15px;
}

.fault-form-compact select {
  background: #495057;
  color: #ecf0f1;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 6px;
  outline: none;
  font-size: 0.85rem;
}

.btn-compact {
  padding: 6px 12px;
  font-size: 0.85rem;
}

.active-faults-compact {
  margin-bottom: 15px;
}

.faults-list-compact {
  max-height: 180px;
  overflow-y: auto;
}

.fault-item-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  margin-bottom: 4px;
  border-radius: 4px;
  border-left: 3px solid;
  font-size: 0.85rem;
}

.fault-item-compact.low {
  background: rgba(40, 167, 69, 0.1);
  border-left-color: #28a745;
}

.fault-item-compact.medium {
  background: rgba(255, 193, 7, 0.1);
  border-left-color: #ffc107;
}

.fault-item-compact.high {
  background: rgba(255, 108, 75, 0.1);
  border-left-color: #ff6c4b;
}

.fault-item-compact.critical {
  background: rgba(220, 53, 69, 0.1);
  border-left-color: #dc3545;
}

.fault-item-compact .fault-info strong {
  color: #FFD700;
  display: block;
  font-size: 0.8rem;
}

.fault-item-compact .fault-time {
  color: #6c757d;
  font-size: 0.7rem;
}

.no-faults-compact {
  text-align: center;
  padding: 15px;
  color: #6c757d;
  font-size: 0.85rem;
}

.opcua-integration-compact {
  text-align: center;
  padding: 8px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.opcua-integration-compact .integration-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.85rem;
}

/* Responsive Design for Compact Layout */
@media (max-width: 800px) {
  .controls-section {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .fault-form-compact {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  
  .quick-metrics-compact {
    justify-content: center;
  }
}


/* OPC UA Connection Status Styles */
.opcua-connection-status {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  border-left: 4px solid #FFD700;
}

.connection-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
}

.connection-indicator .status-led {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.connection-indicator.connected .status-led {
  background: #28a745;
  box-shadow: 0 0 10px rgba(40, 167, 69, 0.5);
}

.connection-indicator.disconnected .status-led {
  background: #dc3545;
  box-shadow: 0 0 10px rgba(220, 53, 69, 0.5);
}

.connection-indicator .status-text {
  color: #FFD700;
  font-weight: bold;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.connection-indicator .server-address {
  color: #6c757d;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 0.9rem;
}

/* Single Turbine Display */
.single-turbine-display {
  margin-top: 20px;
}

.main-turbine-card {
  background: rgba(248, 249, 250, 0.05);
  border-radius: 12px;
  padding: 25px;
  border: 2px solid rgba(255, 215, 0, 0.3);
  max-width: 1200px;
  margin: 0 auto;
}

.turbine-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid rgba(255, 215, 0, 0.5);
}

.turbine-header h3 {
  color: #FFD700;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.8rem;
  margin: 0;
}

.turbine-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.metric-card.primary {
  grid-column: span 2;
  background: rgba(255, 215, 0, 0.1);
  border: 2px solid #FFD700;
}

.metric-card.primary .value {
  font-size: 2.5rem;
  color: #FFD700;
}

.turbine-details {
  background: rgba(0, 0, 0, 0.2);
  padding: 20px;
  border-radius: 8px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.detail-row .label {
  color: #adb5bd;
  font-weight: 500;
}

.detail-row .value {
  color: #ecf0f1;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Connected/Disconnected Status Colors */
.metric-value.connected {
  color: #28a745 !important;
}

.metric-value.disconnected {
  color: #dc3545 !important;
}

/* Estilos para o Sistema de Gerenciamento de Alarmes */
.alarms-management-panel {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 2rem;
  margin: 1rem;
  color: #ecf0f1;
}

.alarms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(255, 215, 0, 0.3);
}

.alarms-header h2 {
  color: #FFD700;
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
}

.alarms-summary {
  display: flex;
  gap: 1rem;
}

.alarm-counter {
  background: rgba(0, 0, 0, 0.4);
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
  min-width: 100px;
  border: 2px solid transparent;
}

.alarm-counter.active {
  border-color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
}

.alarm-counter.total {
  border-color: #6c757d;
  background: rgba(108, 117, 125, 0.1);
}

.counter-value {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
}

.counter-label {
  display: block;
  font-size: 0.9rem;
  color: #adb5bd;
  margin-top: 0.5rem;
}

.active-alarms-section,
.historical-alarms-section {
  margin-bottom: 2rem;
}

.active-alarms-section h3,
.historical-alarms-section h3 {
  color: #FFD700;
  margin-bottom: 1rem;
  font-size: 1.4rem;
}

.alarms-table {
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.table-header {
  display: grid;
  grid-template-columns: 150px 200px 300px 150px 120px 120px;
  background: rgba(255, 215, 0, 0.1);
  padding: 1rem;
  font-weight: 600;
  color: #FFD700;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
}

.table-body {
  max-height: 400px;
  overflow-y: auto;
}

.alarm-row {
  display: grid;
  grid-template-columns: 150px 200px 300px 150px 120px 120px;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.2s ease;
}

.alarm-row:hover {
  background: rgba(255, 255, 255, 0.05);
}

.alarm-row.failure {
  border-left: 4px solid #dc3545;
}

.alarm-row.alert {
  border-left: 4px solid #ffc107;
}

.col-time,
.col-turbine,
.col-description,
.col-type,
.col-status,
.col-actions {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.turbine-id {
  font-weight: 600;
  color: #fff;
}

.turbine-model {
  font-size: 0.85rem;
  color: #adb5bd;
}

.alarm-type-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
}

.alarm-type-badge.warning {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.alarm-type-badge.maintenance {
  background: rgba(23, 162, 184, 0.2);
  color: #17a2b8;
  border: 1px solid rgba(23, 162, 184, 0.3);
}

.alarm-type-badge.inactive {
  background: rgba(220, 53, 69, 0.2);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
}

.status-badge.pending {
  background: rgba(220, 53, 69, 0.2);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.status-badge.acknowledged {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.btn-acknowledge {
  background: #28a745;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-acknowledge:hover {
  background: #218838;
  transform: translateY(-1px);
}

.no-alarms {
  text-align: center;
  padding: 3rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  border: 2px dashed rgba(255, 255, 255, 0.2);
}

.no-alarms-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.no-alarms h4 {
  color: #28a745;
  margin-bottom: 0.5rem;
}

.no-alarms p {
  color: #adb5bd;
  margin: 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.period-selector {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(0, 0, 0, 0.3);
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.period-selector label {
  color: #adb5bd;
  font-weight: 600;
}

.date-input {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 0.5rem;
  border-radius: 4px;
  font-family: inherit;
}

.date-input:focus {
  outline: none;
  border-color: #FFD700;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
}

.btn-extract {
  background: #FFD700;
  color: #000;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-extract:hover {
  background: #ffc107;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}

.historical-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.summary-card {
  background: rgba(0, 0, 0, 0.4);
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.summary-icon {
  font-size: 2.5rem;
  opacity: 0.8;
}

.summary-content h4 {
  color: #FFD700;
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
}

.summary-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  text-align: center;
}

.summary-label {
  color: #adb5bd;
  font-size: 0.8rem;
  margin: 0;
  text-align: center;
}

/* Sistema de Análise de Dados OPC */
.analysis-panel {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);
  color: #ffffff;
  min-height: calc(100vh - 75px);
}

.analysis-header {
  margin-bottom: 2rem;
}

.analysis-header h2 {
  color: #FFD700;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 1px;
}

.analysis-header p {
  color: #adb5bd;
  font-size: 1rem;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.export-options {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.export-section {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.export-section h3 {
  color: #FFD700;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.selection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.selection-option {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-left: 3px solid #6c757d;
  border-radius: 6px;
  padding: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.selection-option:hover {
  border-left-color: #FFD700;
  background: rgba(255, 215, 0, 0.1);
}

.selection-option input[type="radio"] {
  margin-right: 0.75rem;
  scale: 1.2;
}

.selection-option label {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin: 0;
}

.option-title {
  font-weight: 600;
  color: #fff;
  font-size: 1rem;
  margin-bottom: 0.25rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.option-description {
  color: #adb5bd;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.period-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.date-range {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.date-range label {
  color: #adb5bd;
  font-weight: 500;
  font-size: 0.95rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.date-range input {
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  font-size: 0.95rem;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  transition: border-color 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.date-range input:focus {
  outline: none;
  border-color: #FFD700;
  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);
}

.variables-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.variable-category {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 1rem;
}

.variable-category h4 {
  color: #FFD700;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.variable-category label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  color: #adb5bd;
  font-size: 0.9rem;
  padding: 0.25rem 0;
  transition: color 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.variable-category label:hover {
  color: #fff;
}

.variable-category input[type="checkbox"] {
  scale: 1.1;
}

.format-grid {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.format-grid label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  color: #adb5bd;
  transition: all 0.3s ease;
  min-width: 150px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.format-grid label:hover {
  border-color: #FFD700;
  background: rgba(255, 215, 0, 0.1);
  color: #fff;
}

.format-grid input[type="radio"] {
  scale: 1.2;
}

.export-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
}

.preview-button, .export-button {
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.preview-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #495057;
  color: #adb5bd;
}

.preview-button:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: #FFD700;
  color: #FFD700;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);
}

.export-button {
  background: #FFD700;
  border: 1px solid #FFD700;
  color: #2d3436;
}

.export-button:hover {
  background: #ffc107;
  border-color: #ffc107;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
}

.export-info {
  margin-top: 1rem;
}

.info-card {
  background: rgba(33, 150, 243, 0.1);
  border: 1px solid rgba(33, 150, 243, 0.3);
  border-radius: 6px;
  padding: 1rem;
}

.info-card h4 {
  color: #64b5f6;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.info-card ul {
  margin: 0;
  padding-left: 1.25rem;
  color: #adb5bd;
}

.info-card li {
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,cAAc;EACd,8JAA8J;AAChK;;AAEA,WAAW;AACX;EACE,0EAA0E;EAC1E,cAAc;EACd,gCAAgC;EAChC,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAO;AACT;;AAEA,eAAe;AACf;EACE;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAO;AACT;;AAEA,iBAAiB;AACjB;EACE,0EAA0E;EAC1E,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,8JAA8J;EAC9J,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,8JAA8J;EAC9J,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8JAA8J;EAC9J,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,8JAA8J;EAC9J,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,8JAA8J;EAC9J,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,8JAA8J;EAC9J,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,8JAA8J;AAChK;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,8JAA8J;EAC9J,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,8JAA8J;AAChK;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;AAChK;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,8JAA8J;EAC9J,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,qBAAqB;EACrB,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8JAA8J;EAC9J,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8JAA8J;AAChK;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8JAA8J;EAC9J,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8JAA8J;EAC9J,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8JAA8J;EAC9J,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,8JAA8J;AAChK;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8JAA8J;AAChK;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,8JAA8J;EAC9J,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,8JAA8J;AAChK;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,8JAA8J;EAC9J,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA,8BAA8B;AAC9B;EACE,qDAAqD;EACrD,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8JAA8J;AAChK;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;EAC9J,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8JAA8J;EAC9J,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8JAA8J;AAChK;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,eAAe;EACf,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,8JAA8J;EAC9J,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;EAC9J,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,8JAA8J;EAC9J,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8JAA8J;AAChK;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,8JAA8J;EAC9J,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,0CAA0C;AAC1C;EACE,+CAA+C;EAC/C,sDAAsD;EACtD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4FAA4F;EAC5F,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6FAA6F;EAC7F,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8JAA8J;EAC9J,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,wCAAwC;EACxC,8JAA8J;AAChK;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;EAC7B;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,8JAA8J;EAC9J,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8JAA8J;AAChK;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8JAA8J;AAChK;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8JAA8J;EAC9J,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,8JAA8J;EAC9J,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;AAChK;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8JAA8J;EAC9J,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE;;IAEE,0BAA0B;IAC1B,MAAM;EACR;;EAEA;;IAEE,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;;IAEE,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,8JAA8J;EAC9J,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,8JAA8J;EAC9J,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8JAA8J;EAC9J,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8JAA8J;EAC9J,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF;;;;AAIA,6BAA6B;AAC7B;EACE,aAAa;EACb,6DAA6D;EAC7D,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,yBAAyB;EACzB,8JAA8J;AAChK;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA,kCAAkC;AAClC;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;AACF;;;AAGA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,8JAA8J;EAC9J,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8JAA8J;AAChK;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,aAAa;EACb,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,0EAA0E;EAC1E,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,8JAA8J;EAC9J,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,8JAA8J;EAC9J,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,8JAA8J;AAChK;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,8JAA8J;AAChK;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,kCAAkC;EAClC,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;EACjD,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,8JAA8J;AAChK;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,8JAA8J;AAChK;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8JAA8J;AAChK;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8JAA8J;AAChK;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,8JAA8J;AAChK","sourcesContent":["/* Dashboard Container */\n.dashboard-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);\n  color: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Header */\n.dashboard-header {\n  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);\n  color: #495057;\n  border-bottom: 2px solid #636e72;\n  padding: 0.75rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.header-logo {\n  width: 58px;\n  height: 58px;\n  object-fit: contain;\n}\n\n.title-container {\n  display: flex;\n  align-items: baseline;\n  gap: 0.75rem;\n}\n\n.header-title {\n  color: #FFD700;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: 2px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.version-text {\n  color: #495057;\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  opacity: 0.8;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.header-nav {\n  display: flex;\n  gap: 1rem;\n}\n\n.nav-button {\n  background: transparent;\n  border: 2px solid #636e72;\n  color: #495057;\n  padding: 0.5rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.nav-button:hover {\n  background: rgba(255, 215, 0, 0.1);\n  border-color: #FFD700;\n}\n\n.nav-button.active {\n  background: #FFD700;\n  color: #2d3436;\n  border-color: #FFD700;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-info {\n  color: #495057;\n  font-weight: 500;\n}\n\n.logout-button {\n  background: rgba(220, 53, 69, 0.8);\n  border: none;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.logout-button:hover {\n  background: rgba(220, 53, 69, 1);\n}\n\n/* Main Content */\n.dashboard-main {\n  padding: 2rem;\n}\n\n.dashboard-content {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.content-header h2 {\n  color: #ffffff;\n  font-size: 2rem;\n  margin: 0;\n  font-weight: 600;\n}\n\n.status-indicators {\n  display: flex;\n  gap: 2rem;\n}\n\n.status-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n.status-led {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.status-led.active {\n  background: #28a745;\n  box-shadow: 0 0 8px #28a745;\n}\n\n.status-led.warning {\n  background: #ffc107;\n  box-shadow: 0 0 8px #ffc107;\n}\n\n.status-led.critical {\n  background: #dc3545;\n  box-shadow: 0 0 8px #dc3545;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n\n/* Indicators Grid */\n.indicators-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n}\n\n.indicator-card {\n  background: rgba(248, 249, 250, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.indicator-card:hover {\n  background: rgba(248, 249, 250, 0.15);\n  border-color: rgba(255, 215, 0, 0.3);\n}\n\n.indicator-card.large {\n  grid-column: span 2;\n}\n\n.indicator-card.wide {\n  grid-column: span 3;\n}\n\n.indicator-card h3 {\n  color: #ddd;\n  font-size: 0.9rem;\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-weight: 600;\n}\n\n/* Gauge Display */\n.gauge-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 120px;\n}\n\n.gauge-display {\n  text-align: center;\n}\n\n.gauge-value {\n  display: block;\n  font-size: 3rem;\n  font-weight: 700;\n  color: #FFD700;\n  line-height: 1;\n}\n\n.gauge-unit {\n  font-size: 1.2rem;\n  color: #ccc;\n  font-weight: 500;\n}\n\n/* Metric Display */\n.metric-display {\n  text-align: center;\n  padding: 1rem 0;\n}\n\n.metric-value {\n  display: block;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1;\n}\n\n.metric-unit {\n  font-size: 1rem;\n  color: #aaa;\n  font-weight: 500;\n}\n\n/* Chart Placeholder */\n.chart-placeholder {\n  height: 100px;\n  display: flex;\n  align-items: end;\n  justify-content: center;\n}\n\n.chart-bars {\n  display: flex;\n  gap: 8px;\n  height: 80px;\n  align-items: end;\n}\n\n.bar {\n  width: 20px;\n  background: linear-gradient(to top, #FFD700, #ffa500);\n  border-radius: 2px 2px 0 0;\n  min-height: 10px;\n}\n\n/* Alerts List */\n.alerts-list {\n  space-y: 0.5rem;\n}\n\n.alert-item {\n  display: flex;\n  gap: 1rem;\n  padding: 0.75rem;\n  border-radius: 6px;\n  margin-bottom: 0.5rem;\n  border-left: 4px solid;\n}\n\n.alert-item.critical {\n  background: rgba(220, 53, 69, 0.1);\n  border-left-color: #dc3545;\n}\n\n.alert-item.warning {\n  background: rgba(255, 193, 7, 0.1);\n  border-left-color: #ffc107;\n}\n\n.alert-time {\n  color: #aaa;\n  font-weight: 600;\n  min-width: 60px;\n}\n\n.alert-message {\n  color: #fff;\n  flex: 1;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .indicator-card.large,\n  .indicator-card.wide {\n    grid-column: span 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-header {\n    padding: 0.5rem 1rem;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .content-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: start;\n  }\n  \n  .status-indicators {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .dashboard-main {\n    padding: 1rem;\n  }\n  \n  .indicators-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Dashboard Body */\n.dashboard-body {\n  display: flex;\n  flex: 1;\n}\n\n/* Menu Lateral */\n.sidebar {\n  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);\n  border-right: 2px solid #636e72;\n  transition: all 0.3s ease;\n  height: calc(100vh - 75px);\n  overflow-y: auto;\n  position: sticky;\n  top: 0;\n}\n\n.sidebar.open {\n  width: 250px;\n}\n\n.sidebar.closed {\n  width: 60px;\n}\n\n.sidebar-header {\n  padding: 1rem;\n  border-bottom: 1px solid rgba(99, 110, 114, 0.3);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sidebar-header h3 {\n  color: #495057;\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  letter-spacing: 1px;\n}\n\n.sidebar-toggle {\n  background: none;\n  border: 1px solid #636e72;\n  color: #495057;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  transition: all 0.3s ease;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(255, 215, 0, 0.1);\n  border-color: #FFD700;\n}\n\n.sidebar-nav {\n  padding: 1rem 0;\n}\n\n.sidebar-item {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: none;\n  border: none;\n  color: #495057;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.sidebar-item:hover {\n  background: rgba(255, 215, 0, 0.1);\n  color: #2d3436;\n}\n\n.sidebar-item.active {\n  background: #FFD700;\n  color: #2d3436;\n  font-weight: 600;\n  border-right: 3px solid #2d3436;\n}\n\n.sidebar.closed .sidebar-item {\n  justify-content: center;\n  padding: 0.75rem 0.5rem;\n}\n\n.sidebar.closed .sidebar-header h3 {\n  display: none;\n}\n\n.sidebar-divider {\n  height: 1px;\n  background: rgba(99, 110, 114, 0.3);\n  margin: 0.5rem 1rem;\n}\n\n.sidebar.closed .sidebar-divider {\n  margin: 0.5rem;\n}\n\n/* Ajuste no Main Content */\n.dashboard-main {\n  flex: 1;\n  padding: 2rem;\n  overflow-y: auto;\n  background: #2d3436;\n}\n\n.config-panel {\n  background: rgba(248, 249, 250, 0.1);\n  border-radius: 12px;\n  padding: 2rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.config-panel h2 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n}\n\n.config-panel p {\n  color: #ccc;\n}\n\n.system-status {\n  color: #28a745;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n/* Submenu Styles */\n.submenu-arrow {\n  margin-left: auto;\n  transition: transform 0.3s ease;\n  font-size: 0.8rem;\n}\n\n.submenu-arrow.open {\n  transform: rotate(180deg);\n}\n\n.submenu {\n  margin-left: 1rem;\n  border-left: 2px solid #495057;\n  padding-left: 0.5rem;\n}\n\n.submenu-item {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  background: none;\n  border: none;\n  color: #6c757d;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.85rem;\n  font-weight: 400;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.submenu-item:hover {\n  color: #FFD700;\n  background: rgba(255, 215, 0, 0.1);\n}\n\n.submenu-item.active {\n  color: #FFD700;\n  background: rgba(255, 215, 0, 0.15);\n  border-left: 3px solid #FFD700;\n}\n\n/* Submenu Main Info Styling */\n.submenu-main-info {\n  width: 100%;\n  text-align: left;\n}\n\n.submenu-main-title {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 0.85rem;\n  margin-bottom: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.submenu-turbine-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid rgba(108, 117, 125, 0.3);\n}\n\n.submenu-turbine-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.25rem 0;\n  font-size: 0.7rem;\n  gap: 0.5rem;\n}\n\n.turbine-id {\n  font-weight: 700;\n  color: #FFD700;\n  min-width: 70px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.turbine-model {\n  color: #adb5bd;\n  font-size: 0.65rem;\n  flex: 1;\n}\n\n.connection-type {\n  color: #6c757d;\n  font-size: 0.6rem;\n  font-style: italic;\n  text-align: right;\n  min-width: 80px;\n}\n\n.turbine-power {\n  color: #28a745;\n  font-weight: 600;\n  min-width: 50px;\n  text-align: right;\n}\n\n.turbine-wind {\n  color: #17a2b8;\n  font-weight: 500;\n  min-width: 45px;\n  text-align: right;\n}\n\n.status-dot {\n  font-size: 0.6rem;\n  margin-left: auto;\n}\n\n.status-dot.operational {\n  color: #28a745;\n}\n\n.status-dot.warning {\n  color: #ffc107;\n}\n\n.status-dot.maintenance {\n  color: #6c757d;\n}\n\n.status-dot.inactive {\n  color: #dc3545;\n}\n\n/* Enhanced submenu item for complex content */\n.submenu-item:has(.submenu-main-info) {\n  padding: 0.75rem;\n  min-height: auto;\n}\n\n.submenu-item:has(.submenu-main-info):hover {\n  background: rgba(255, 215, 0, 0.1);\n  border-left: 3px solid #FFD700;\n}\n\n.submenu-item:has(.submenu-main-info).active {\n  background: rgba(255, 215, 0, 0.15);\n  border-left: 3px solid #FFD700;\n}\n\n/* OPC UA Servers Grid */\n.opcua-servers-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.server-info-card {\n  background: rgba(40, 44, 52, 0.9);\n  border: 1px solid rgba(108, 117, 125, 0.3);\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.server-info-card h4 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.connection-status.active {\n  color: #28a745;\n  font-weight: 600;\n}\n\n.connection-status.inactive {\n  color: #dc3545;\n  font-weight: 600;\n}\n\n/* Single Column Simulator Layout */\n.simulator-single-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  width: 100%;\n}\n\n.simulator-single-layout .simulator-card {\n  background: rgba(40, 44, 52, 0.9);\n  border: 1px solid rgba(108, 117, 125, 0.3);\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1400px) {\n  .opcua-servers-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .simulator-single-layout {\n    gap: 1rem;\n  }\n}\n\n/* Form Styles */\n.config-form {\n  margin-top: 1.5rem;\n}\n\n.form-section {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.form-section h3 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.1rem;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  color: #ccc;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 500;\n}\n\n.form-group input,\n.form-group select {\n  padding: 0.75rem;\n  border: 1px solid #495057;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #FFD700;\n  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\n}\n\n.form-group input::placeholder {\n  color: #6c757d;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.btn-primary {\n  background: linear-gradient(145deg, #FFD700, #FFA500);\n  color: #2d3436;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(145deg, #FFA500, #FFD700);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);\n}\n\n.btn-secondary {\n  background: rgba(108, 117, 125, 0.2);\n  color: #ccc;\n  border: 1px solid #6c757d;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover {\n  background: rgba(108, 117, 125, 0.3);\n  color: #fff;\n  border-color: #adb5bd;\n}\n\n/* Estilos para Parques */\n.parques-list {\n  margin-top: 1rem;\n}\n\n.parque-item {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.parque-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #FFD700;\n}\n\n.parque-info h4 {\n  color: #FFD700;\n  margin-bottom: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.parque-info p {\n  color: #ccc;\n  margin: 0.25rem 0;\n  font-size: 0.9rem;\n}\n\n.parque-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n/* Botões pequenos */\n.btn-small {\n  padding: 0.5rem 1rem;\n  font-size: 0.8rem;\n  border-radius: 4px;\n}\n\n.btn-danger {\n  background: linear-gradient(145deg, #dc3545, #c82333);\n  color: white;\n  border: none;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-danger:hover {\n  background: linear-gradient(145deg, #c82333, #dc3545);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n}\n\n/* Grid de Aerogeradores */\n.aerogeradores-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.aerogerador-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1rem;\n  transition: all 0.3s ease;\n}\n\n.aerogerador-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #FFD700;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.card-header h5 {\n  color: #FFD700;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.1rem;\n}\n\n.status-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Aerogerador SVG animado */\n.turbine-icon {\n  width: 20px;\n  height: 20px;\n  display: block;\n  margin: 0 auto;\n}\n\n/* Animação maior na tela inicial */\n.park-card .turbine-icon {\n  width: 40px;\n  height: 40px;\n}\n\n.park-card .turbine-rotor {\n  transform-origin: 12px 8px;\n}\n\n.turbine-rotor {\n  transform-origin: 12px 8px;\n  animation: spin 2s linear infinite;\n}\n\n.turbine-rotor.operational {\n  animation-duration: 1.5s;\n}\n\n.turbine-rotor.maintenance {\n  animation-duration: 4s;\n}\n\n.turbine-rotor.warning {\n  animation-duration: 3s;\n}\n\n.turbine-rotor.inactive {\n  animation: none;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.turbine-tower.operational {\n  stroke: #28a745;\n  fill: #28a745;\n}\n\n.turbine-blades.operational {\n  stroke: #28a745;\n  fill: #28a745;\n}\n\n.turbine-tower.maintenance {\n  stroke: #ffc107;\n  fill: #ffc107;\n}\n\n.turbine-blades.maintenance {\n  stroke: #ffc107;\n  fill: #ffc107;\n}\n\n.turbine-tower.warning {\n  stroke: #ff6b35;\n  fill: #ff6b35;\n}\n\n.turbine-blades.warning {\n  stroke: #ff6b35;\n  fill: #ff6b35;\n}\n\n.turbine-tower.inactive {\n  stroke: #dc3545;\n  fill: #dc3545;\n}\n\n.turbine-blades.inactive {\n  stroke: #dc3545;\n  fill: #dc3545;\n}\n\n.card-content p {\n  color: #ccc;\n  margin: 0.25rem 0;\n  font-size: 0.85rem;\n}\n\n.card-actions {\n  margin-top: 0.75rem;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.aerogerador-form {\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 6px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.aerogerador-form h4 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Tabela de Aerogeradores */\n.aerogeradores-table {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #495057;\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr 1.5fr 1fr 1fr 1.5fr;\n  background: rgba(255, 215, 0, 0.1);\n  border-bottom: 2px solid #FFD700;\n  font-weight: 600;\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n.table-header > div {\n  padding: 1rem;\n  text-align: center;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr 1.5fr 1fr 1fr 1.5fr;\n  border-bottom: 1px solid #495057;\n  transition: all 0.3s ease;\n}\n\n.table-row:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.table-row > div {\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ccc;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.table-row > div:last-child {\n  gap: 0.5rem;\n}\n\n/* Dashboard de Projetos */\n.projects-overview {\n  margin-bottom: 2rem;\n}\n\n.project-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.summary-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1.5rem;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.summary-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #FFD700;\n  transform: translateY(-2px);\n}\n\n.summary-card h3 {\n  color: #FFD700;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  text-align: center;\n}\n\n/* Parques Dashboard */\n.parks-dashboard h3 {\n  color: #FFD700;\n  margin-bottom: 1.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n}\n\n.park-cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.park-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1rem;\n  transition: all 0.3s ease;\n  min-width: 0;\n}\n\n.park-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #FFD700;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.park-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  border-bottom: 1px solid #495057;\n  padding-bottom: 0.5rem;\n}\n\n.park-header h4 {\n  color: #FFD700;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.95rem;\n}\n\n.park-code {\n  background: rgba(255, 215, 0, 0.2);\n  color: #FFD700;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.park-info {\n  margin-bottom: 1rem;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.3rem;\n  color: #ccc;\n  font-size: 0.85rem;\n  font-size: 0.9rem;\n}\n\n.info-row span:first-child {\n  font-weight: 600;\n  color: #adb5bd;\n}\n\n/* Turbinas Grid */\n.turbines-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n}\n\n.turbine-item {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid #495057;\n  border-radius: 4px;\n  padding: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.turbine-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: #6c757d;\n}\n\n.turbine-id {\n  color: #FFD700;\n  font-weight: 600;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  margin-bottom: 0.25rem;\n}\n\n.turbine-model {\n  color: #adb5bd;\n  font-size: 0.8rem;\n  margin-bottom: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.turbine-status {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n\n.power-output {\n  color: #28a745;\n  font-weight: 600;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Condições Ambientais */\n.environmental-conditions {\n  margin-bottom: 2rem;\n}\n\n.environmental-conditions h3 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.2rem;\n}\n\n.conditions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.condition-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1rem;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.condition-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #6c757d;\n}\n\n.condition-card h4 {\n  color: #adb5bd;\n  margin-bottom: 0.75rem;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Alertas */\n.alerts-section h3 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.2rem;\n}\n\n.alerts-list .alert-item {\n  display: grid;\n  grid-template-columns: 80px 1fr 150px;\n  gap: 1rem;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid #495057;\n  border-radius: 6px;\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  transition: all 0.3s ease;\n}\n\n.alerts-list .alert-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: #6c757d;\n}\n\n.alert-park {\n  color: #6c757d;\n  font-size: 0.8rem;\n  font-style: italic;\n  text-align: right;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.alert-item.info {\n  border-left: 4px solid #17a2b8;\n}\n\n.alert-item.info .alert-time {\n  color: #17a2b8;\n}\n\n/* Complexos Dashboard */\n.complexes-dashboard h3 {\n  color: #FFD700;\n  margin-bottom: 2rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.4rem;\n}\n\n.complex-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px solid #495057;\n  border-radius: 16px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  transition: all 0.3s ease;\n}\n\n.complex-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #FFD700;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\n}\n\n.complex-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 2px solid #FFD700;\n  padding-bottom: 1rem;\n}\n\n.complex-header h4 {\n  color: #FFD700;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  font-weight: 700;\n}\n\n.complex-code {\n  background: linear-gradient(145deg, #FFD700, #FFA500);\n  color: #2d3436;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);\n}\n\n.complex-info {\n  margin-bottom: 2rem;\n}\n\n.parks-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n}\n\n.park-header h5 {\n  color: #FFD700;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n.park-summary {\n  color: #adb5bd;\n  font-size: 0.85rem;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Tree Structure */\n.complexes-tree {\n  margin-top: 1rem;\n}\n\n.complex-tree-item {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.complex-tree-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #FFD700;\n}\n\n.complex-tree-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.complex-tree-header h4 {\n  color: #FFD700;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.1rem;\n}\n\n.complex-tree-info {\n  margin-bottom: 1rem;\n  color: #ccc;\n  font-size: 0.9rem;\n}\n\n.parks-tree {\n  margin-left: 2rem;\n  border-left: 2px solid #495057;\n  padding-left: 1rem;\n  margin-bottom: 1rem;\n}\n\n.park-tree-item {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid #6c757d;\n  border-radius: 6px;\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  transition: all 0.3s ease;\n}\n\n.park-tree-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: #adb5bd;\n}\n\n.park-tree-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.park-tree-header h5 {\n  color: #adb5bd;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n.tree-code {\n  background: rgba(255, 215, 0, 0.15);\n  color: #FFD700;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.tree-actions {\n  margin-top: 1rem;\n  display: flex;\n  gap: 0.75rem;\n}\n\n/* Turbinas Clicáveis */\n.turbine-item.clickable {\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.turbine-item.clickable:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #FFD700;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);\n}\n\n/* Tela de Detalhes do Aerogerador */\n.turbine-details-panel {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.details-header {\n  margin-bottom: 2rem;\n}\n\n.back-navigation {\n  margin-bottom: 1rem;\n}\n\n.btn-back {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid #495057;\n  color: #adb5bd;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.btn-back:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: #FFD700;\n  color: #FFD700;\n  transform: translateX(-2px);\n}\n\n.details-header h2 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n}\n\n.turbine-summary {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.turbine-model {\n  background: rgba(255, 255, 255, 0.1);\n  color: #adb5bd;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n/* Métricas Operacionais */\n.operational-metrics {\n  margin-bottom: 2rem;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.metric-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.metric-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #6c757d;\n}\n\n.metric-card.primary {\n  border-color: #FFD700;\n  background: rgba(255, 215, 0, 0.05);\n}\n\n.metric-card.primary:hover {\n  background: rgba(255, 215, 0, 0.1);\n  border-color: #FFD700;\n}\n\n.metric-card h3 {\n  color: #adb5bd;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.metric-display.large .metric-value {\n  font-size: 3rem;\n  color: #FFD700;\n}\n\n.metric-display.large .metric-unit {\n  font-size: 1.2rem;\n}\n\n.metric-percentage {\n  color: #28a745;\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.metric-trend {\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.metric-trend.positive {\n  color: #28a745;\n}\n\n.metric-trend.stable {\n  color: #ffc107;\n}\n\n.metric-trend.negative {\n  color: #dc3545;\n}\n\n/* Parâmetros Técnicos */\n.technical-parameters {\n  margin-bottom: 2rem;\n}\n\n.technical-parameters h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  margin-bottom: 1.5rem;\n}\n\n.parameters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.parameter-section {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.parameter-section h4 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1rem;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid #495057;\n  padding-bottom: 0.5rem;\n}\n\n.parameter-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.parameter-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n}\n\n.param-label {\n  color: #adb5bd;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.param-value {\n  font-weight: 600;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.param-value.good {\n  color: #28a745;\n}\n\n.param-value.warning {\n  color: #ffc107;\n}\n\n.param-value.critical {\n  color: #dc3545;\n}\n\n/* Painel de Controle */\n.control-panel {\n  margin-bottom: 2rem;\n}\n\n.control-panel h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  margin-bottom: 1.5rem;\n}\n\n.controls-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 2rem;\n}\n\n.control-section {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.control-section h4 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1rem;\n  margin-bottom: 1rem;\n}\n\n.control-buttons {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.control-btn {\n  padding: 1rem;\n  border: none;\n  border-radius: 8px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.control-btn.start {\n  background: linear-gradient(145deg, #28a745, #20c997);\n  color: white;\n}\n\n.control-btn.start:hover {\n  background: linear-gradient(145deg, #20c997, #28a745);\n  transform: translateY(-2px);\n}\n\n.control-btn.stop {\n  background: linear-gradient(145deg, #dc3545, #fd7e14);\n  color: white;\n}\n\n.control-btn.stop:hover {\n  background: linear-gradient(145deg, #fd7e14, #dc3545);\n  transform: translateY(-2px);\n}\n\n.control-btn.maintenance {\n  background: linear-gradient(145deg, #ffc107, #fd7e14);\n  color: #2d3436;\n}\n\n.control-btn.maintenance:hover {\n  background: linear-gradient(145deg, #fd7e14, #ffc107);\n  transform: translateY(-2px);\n}\n\n.control-btn.reset {\n  background: linear-gradient(145deg, #6c757d, #adb5bd);\n  color: white;\n}\n\n.control-btn.reset:hover {\n  background: linear-gradient(145deg, #adb5bd, #6c757d);\n  transform: translateY(-2px);\n}\n\n.control-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.setting-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.setting-item label {\n  color: #adb5bd;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.setting-item input[type=\"range\"] {\n  width: 100%;\n}\n\n.setting-item select {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid #495057;\n  color: #fff;\n  padding: 0.5rem;\n  border-radius: 4px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Log de Eventos */\n.events-log {\n  margin-bottom: 2rem;\n}\n\n.events-log h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  margin-bottom: 1.5rem;\n}\n\n.events-list {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.event-item {\n  display: grid;\n  grid-template-columns: 80px 1fr 120px;\n  gap: 1rem;\n  align-items: center;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.event-item:last-child {\n  border-bottom: none;\n}\n\n.event-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.event-time {\n  color: #6c757d;\n  font-size: 0.8rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.event-message {\n  color: #ccc;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.event-type {\n  color: #adb5bd;\n  font-size: 0.8rem;\n  text-align: right;\n  font-style: italic;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.event-item.warning .event-time {\n  color: #ffc107;\n}\n\n.event-item.warning .event-message {\n  color: #ffc107;\n}\n\n/* Indicador de última atualização */\n.metric-info {\n  margin-top: 0.5rem;\n}\n\n.metric-info small {\n  color: #6c757d;\n  font-size: 0.75rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Status badge para warning */\n.status-badge.warning {\n  background: linear-gradient(145deg, #ffc107, #fd7e14);\n  color: #2d3436;\n  animation: pulse-warning 2s infinite;\n}\n\n@keyframes pulse-warning {\n  0%, 100% {\n    box-shadow: 0 0 8px rgba(255, 193, 7, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 16px rgba(255, 193, 7, 0.8);\n  }\n}\n\n/* Botões desabilitados */\n.control-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* Seção Curva de Potência */\n.power-curve-section {\n  margin-bottom: 2rem;\n}\n\n.power-curve-section h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  margin-bottom: 1.5rem;\n}\n\n.chart-container {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.chart-header {\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #495057;\n}\n\n.current-point {\n  color: #adb5bd;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n.current-point strong {\n  color: #FFD700;\n}\n\n.curve-specs {\n  display: flex;\n  gap: 1.5rem;\n  margin-top: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.spec-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.spec-label {\n  color: #6c757d;\n  font-size: 0.75rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.spec-value {\n  color: #28a745;\n  font-size: 0.85rem;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.power-curve-chart {\n  width: 100%;\n  height: 400px;\n}\n\n.curve-svg {\n  width: 100%;\n  height: 100%;\n}\n\n/* Seção Histórico Diário */\n.daily-history-section {\n  margin-bottom: 2rem;\n}\n\n.daily-history-section h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  margin-bottom: 1.5rem;\n}\n\n.history-container {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.history-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #495057;\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.summary-label {\n  color: #adb5bd;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  text-align: center;\n}\n\n.summary-value {\n  color: #FFD700;\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  text-align: center;\n}\n\n.history-chart {\n  width: 100%;\n  height: 300px;\n  margin-bottom: 2rem;\n}\n\n.history-svg {\n  width: 100%;\n  height: 100%;\n}\n\n.history-table {\n  overflow-x: auto;\n}\n\n.history-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.history-table th,\n.history-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.history-table th {\n  color: #FFD700;\n  font-weight: 600;\n  background: rgba(255, 215, 0, 0.05);\n}\n\n.history-table td {\n  color: #adb5bd;\n}\n\n.history-table tr.maintenance-day {\n  background: rgba(220, 53, 69, 0.05);\n}\n\n.availability-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.availability-badge.good {\n  background: rgba(40, 167, 69, 0.2);\n  color: #28a745;\n}\n\n.availability-badge.low {\n  background: rgba(220, 53, 69, 0.2);\n  color: #dc3545;\n}\n\n/* Responsividade para gráficos */\n@media (max-width: 768px) {\n  .chart-container,\n  .history-container {\n    padding: 1rem;\n  }\n  \n  .power-curve-chart {\n    height: 300px;\n  }\n  \n  .history-chart {\n    height: 250px;\n  }\n  \n  .history-summary {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n/* Centro de Operações - Monitoramento Operacional */\n.operational-dashboard {\n  padding: 2rem;\n  max-width: 100%;\n  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);\n  min-height: 100vh;\n}\n\n.operational-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #FFD700;\n}\n\n.operational-header h2 {\n  color: #FFD700;\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.operational-controls {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n/* Painel de Status Crítico - Compacto */\n.critical-status-panel {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid #636e72;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.critical-status-panel h3 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.status-overview-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.75rem;\n}\n\n.status-metric {\n  background: linear-gradient(145deg, #495057 0%, #6c757d 100%);\n  border-radius: 6px;\n  padding: 0.75rem;\n  text-align: center;\n  border: 1px solid #636e72;\n  transition: all 0.3s ease;\n  min-height: 80px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.status-metric:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 3px 10px rgba(255, 215, 0, 0.2);\n}\n\n.metric-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  margin-bottom: 0.5rem;\n}\n\n.metric-header h4 {\n  color: #ffffff;\n  margin: 0;\n  font-size: 0.75rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 500;\n}\n\n.capacity-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #17a2b8;\n  box-shadow: 0 0 6px #17a2b8;\n  animation: pulse 2s infinite;\n}\n\n.metric-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  margin: 0.25rem 0;\n  line-height: 1;\n}\n\n.metric-subtitle {\n  color: #adb5bd;\n  font-size: 0.7rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.9;\n}\n\n/* Mapa Visual dos Aerogeradores */\n.turbines-visual-map {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid #636e72;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.turbines-visual-map h3 {\n  color: #FFD700;\n  margin-bottom: 2rem;\n  font-size: 1.3rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.complexes-operational-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n  max-width: 100%;\n}\n\n.complex-operational-section {\n  background: rgba(73, 80, 87, 0.3);\n  border: 1px solid #495057;\n  border-radius: 8px;\n  padding: 1.5rem;\n  min-width: 0;\n}\n\n.complex-operational-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.2rem;\n  padding-bottom: 0.8rem;\n  border-bottom: 1px solid #636e72;\n}\n\n.complex-operational-header h4 {\n  color: #ffffff;\n  margin: 0;\n  font-size: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.complex-stats {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.complex-power {\n  color: #28a745;\n  font-weight: 700;\n  font-size: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.complex-efficiency {\n  color: #adb5bd;\n  font-size: 0.8rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.parks-operational-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.park-operational-section {\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 215, 0, 0.3);\n  border-radius: 6px;\n  padding: 1rem;\n}\n\n.park-operational-section h5 {\n  color: #FFD700;\n  margin-bottom: 0.8rem;\n  font-size: 0.85rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.turbines-status-visual {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  justify-content: flex-start;\n}\n\n.turbine-visual-indicator {\n  position: relative;\n  width: 50px;\n  height: 60px;\n  background: linear-gradient(145deg, #495057 0%, #343a40 100%);\n  border: 2px solid #6c757d;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0.3rem;\n  text-align: center;\n}\n\n.turbine-visual-indicator:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);\n  border-color: #FFD700;\n}\n\n.turbine-visual-indicator.operational {\n  border-color: #28a745;\n  box-shadow: 0 0 10px rgba(40, 167, 69, 0.3);\n}\n\n.turbine-visual-indicator.warning {\n  border-color: #ffc107;\n  box-shadow: 0 0 10px rgba(255, 193, 7, 0.3);\n}\n\n.turbine-visual-indicator.maintenance {\n  border-color: #6f42c1;\n  box-shadow: 0 0 10px rgba(111, 66, 193, 0.3);\n}\n\n.turbine-visual-indicator.inactive {\n  border-color: #dc3545;\n  box-shadow: 0 0 10px rgba(220, 53, 69, 0.3);\n}\n\n.turbine-visual-id {\n  color: #ffffff;\n  font-size: 0.55rem;\n  font-weight: 600;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.turbine-visual-power {\n  color: #FFD700;\n  font-size: 0.5rem;\n  font-weight: 700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.turbine-visual-status {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin: 0 auto;\n  animation: pulse 2s infinite;\n}\n\n.turbine-visual-status.operational {\n  background: #28a745;\n  box-shadow: 0 0 6px #28a745;\n}\n\n.turbine-visual-status.warning {\n  background: #ffc107;\n  box-shadow: 0 0 6px #ffc107;\n}\n\n.turbine-visual-status.maintenance {\n  background: #6f42c1;\n  box-shadow: 0 0 6px #6f42c1;\n}\n\n.turbine-visual-status.inactive {\n  background: #dc3545;\n  box-shadow: 0 0 6px #dc3545;\n}\n\n/* Performance Consolidado - Mais Compacto */\n.consolidated-performance {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid #636e72;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.consolidated-performance h3 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.performance-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.performance-card {\n  background: linear-gradient(145deg, #495057 0%, #6c757d 100%);\n  border: 1px solid #636e72;\n  border-radius: 6px;\n  padding: 1rem;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.performance-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);\n}\n\n.performance-card h4 {\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n  font-size: 0.85rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.performance-value {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  margin-bottom: 0.3rem;\n}\n\n.performance-trend {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: #adb5bd;\n  font-size: 0.8rem;\n}\n\n.trend-indicator {\n  font-weight: 700;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n}\n\n.trend-indicator.positive {\n  background: rgba(40, 167, 69, 0.2);\n  color: #28a745;\n}\n\n.performance-subtitle {\n  color: #adb5bd;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* Legenda Operacional - Compacta */\n.operational-legend {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid #636e72;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.operational-legend h4 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-size: 0.95rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.legend-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.8rem;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  color: #adb5bd;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.turbine-visual-indicator.small {\n  width: 30px;\n  height: 35px;\n  padding: 0.2rem;\n  transform: none;\n}\n\n.turbine-visual-indicator.small:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.turbine-visual-indicator.small .turbine-visual-status {\n  width: 6px;\n  height: 6px;\n}\n\n/* Responsividade para centro de operações */\n@media (max-width: 768px) {\n  .operational-dashboard {\n    padding: 0.5rem;\n  }\n  \n  .operational-header {\n    margin-bottom: 1rem;\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .complexes-operational-grid {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n  \n  .complex-operational-section {\n    padding: 1rem;\n  }\n  \n  .complex-stats {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n  \n  .status-overview-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n  }\n  \n  .status-metric {\n    min-height: 70px;\n    padding: 0.5rem;\n  }\n  \n  .metric-value {\n    font-size: 1.4rem;\n  }\n  \n  .metric-subtitle {\n    font-size: 0.65rem;\n  }\n  \n  .performance-metrics-grid {\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 0.5rem;\n  }\n  \n  .parks-operational-container {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n  \n  .turbines-status-visual {\n    justify-content: center;\n    gap: 0.3rem;\n  }\n  \n  .turbine-visual-indicator {\n    width: 40px;\n    height: 50px;\n  }\n  \n  .turbine-visual-id {\n    font-size: 0.45rem;\n  }\n  \n  .turbine-visual-power {\n    font-size: 0.4rem;\n  }\n}\n\n/* Novos elementos para o complexo único */\n.more-turbines {\n  background: rgba(108, 117, 125, 0.3) !important;\n  border: 2px dashed rgba(108, 117, 125, 0.6) !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #6c757d;\n  cursor: default;\n}\n\n.more-count {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n}\n\n.more-text {\n  font-size: 0.75rem;\n  opacity: 0.8;\n}\n\n.more-parks-indicator {\n  grid-column: 1 / -1;\n  margin-top: 1rem;\n}\n\n.more-parks-card {\n  background: linear-gradient(145deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 215, 0, 0.05) 100%);\n  border: 2px solid rgba(255, 215, 0, 0.3);\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.more-parks-card:hover {\n  background: linear-gradient(145deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 215, 0, 0.08) 100%);\n  border-color: rgba(255, 215, 0, 0.5);\n  transform: translateY(-2px);\n}\n\n.more-parks-card h5 {\n  color: #FFD700;\n  margin: 0 0 0.5rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.more-parks-card p {\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0 0 1rem 0;\n  font-size: 0.9rem;\n}\n\n.view-all-btn {\n  background: linear-gradient(145deg, #636e72 0%, #2d3436 100%);\n  border: 2px solid #FFD700;\n  color: #FFD700;\n  padding: 0.75rem 2rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  letter-spacing: 1px;\n}\n\n.view-all-btn:hover {\n  background: linear-gradient(145deg, #FFD700 0%, #ffc107 100%);\n  color: #2d3436;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.4);\n}\n\n.complex-location {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.85rem;\n  margin-left: 1rem;\n}\n\n/* Indicador de atualização em tempo real */\n.update-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #495057;\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.update-pulse {\n  width: 8px;\n  height: 8px;\n  background: #28a745;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.system-status {\n  color: #28a745;\n  font-weight: 600;\n  font-size: 0.9rem;\n  padding: 0.5rem 1rem;\n  background: rgba(40, 167, 69, 0.1);\n  border-radius: 6px;\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n/* Indicador de alarme */\n.alarm-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #dc3545;\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  background: rgba(220, 53, 69, 0.1);\n  border-radius: 6px;\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.alarm-status.clickable {\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.alarm-status.clickable:hover {\n  background: rgba(220, 53, 69, 0.2);\n  border-color: rgba(220, 53, 69, 0.5);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n}\n\n.alarm-indicator {\n  width: 8px;\n  height: 8px;\n  background: #dc3545;\n  border-radius: 50%;\n  animation: alarmBlink 1s infinite;\n}\n\n@keyframes alarmBlink {\n  0%, 50% {\n    opacity: 1;\n    transform: scale(1);\n    box-shadow: 0 0 8px #dc3545;\n  }\n  51%, 100% {\n    opacity: 0.3;\n    transform: scale(0.8);\n    box-shadow: 0 0 4px #dc3545;\n  }\n}\n\n/* Indicador de status HTTP */\n.http-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  transition: all 0.3s ease;\n}\n\n.http-status.available {\n  color: #28a745;\n  background: rgba(40, 167, 69, 0.1);\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.http-status.unavailable {\n  color: #ffc107;\n  background: rgba(255, 193, 7, 0.1);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.status-dot.online {\n  background: #28a745;\n  box-shadow: 0 0 6px #28a745;\n  animation: pulse 2s infinite;\n}\n\n.status-dot.offline {\n  background: #ffc107;\n  box-shadow: 0 0 6px #ffc107;\n  animation: statusBlink 1.5s infinite;\n}\n\n@keyframes statusBlink {\n  0%, 70% {\n    opacity: 1;\n  }\n  71%, 100% {\n    opacity: 0.4;\n  }\n}\n\n/* Botão de teste de alarme */\n.test-alarm-btn {\n  background: linear-gradient(145deg, #6f42c1 0%, #563d7c 100%);\n  border: 2px solid #6f42c1;\n  color: #ffffff;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.test-alarm-btn:hover {\n  background: linear-gradient(145deg, #563d7c 0%, #6f42c1 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(111, 66, 193, 0.4);\n}\n\n/* Botão de teste de popup */\n.test-popup-btn {\n  background: linear-gradient(145deg, #dc3545 0%, #a71e2a 100%);\n  border: 2px solid #dc3545;\n  color: #ffffff;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.test-popup-btn:hover {\n  background: linear-gradient(145deg, #a71e2a 0%, #dc3545 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);\n}\n\n/* Notificação de Falha/Manutenção */\n.failure-notification-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(5px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.failure-notification-modal {\n  background: linear-gradient(145deg, #2a2a2a 0%, #1e1e1e 100%);\n  border: 2px solid #555;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\n  animation: slideIn 0.4s ease-out;\n}\n\n.notification-header {\n  display: flex;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 2px solid #444;\n  position: relative;\n}\n\n.notification-header.failure {\n  background: linear-gradient(145deg, #dc3545 0%, #a71e2a 100%);\n  border-bottom-color: #a71e2a;\n}\n\n.notification-timer {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.8rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Overlay para múltiplas notificações */\n.failure-notifications-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  backdrop-filter: blur(4px);\n  padding: 2rem;\n}\n\n/* Grade de notificações */\n.failure-notifications-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 1.5rem;\n  max-width: 1400px;\n  max-height: 90vh;\n  overflow-y: auto;\n  width: 100%;\n}\n\n/* Responsividade para múltiplos popups */\n@media (max-width: 1200px) {\n  .failure-notifications-grid {\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .failure-notifications-grid {\n    grid-template-columns: 1fr;\n    gap: 0.8rem;\n  }\n  \n  .failure-notifications-overlay {\n    padding: 1rem;\n  }\n}\n\n/* Estilos para o Emulador OPC UA */\n.turbines-panel {\n  padding: 2rem;\n  background: #f8f9fa;\n  min-height: calc(100vh - 80px);\n}\n\n.opcua-emulator {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.emulator-header {\n  background: linear-gradient(135deg, #2d3436 0%, #636e72 100%);\n  color: white;\n  padding: 1.5rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.emulator-header h3 {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.server-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.status-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #28a745;\n  animation: pulse 2s infinite;\n}\n\n.status-indicator.running {\n  background: #28a745;\n  animation: pulse 2s infinite;\n}\n\n.status-indicator.stopped {\n  background: #dc3545;\n  animation: none;\n}\n\n.status-indicator.transitioning {\n  background: #ffc107;\n  animation: blink 1s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n  }\n}\n\n@keyframes blink {\n  0%, 50% {\n    opacity: 1;\n  }\n  51%, 100% {\n    opacity: 0.5;\n  }\n}\n\n.emulator-content {\n  padding: 2rem;\n}\n\n.connection-info {\n  margin-bottom: 2rem;\n}\n\n.connection-info h4 {\n  color: #2d3436;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.connection-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.connection-item {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #FFD700;\n}\n\n.connection-item label {\n  display: block;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.connection-value {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  color: #2d3436;\n  font-weight: 500;\n  word-break: break-all;\n}\n\n.variables-section {\n  margin-bottom: 2rem;\n}\n\n.variables-section h4 {\n  color: #2d3436;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.variables-table {\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 2fr 3fr 1fr 1.5fr 1fr;\n  background: #495057;\n  color: white;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.table-header span,\n.table-row span {\n  padding: 1rem 0.75rem;\n  border-right: 1px solid #dee2e6;\n}\n\n.table-header span:last-child,\n.table-row span:last-child {\n  border-right: none;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 2fr 3fr 1fr 1.5fr 1fr;\n  border-bottom: 1px solid #dee2e6;\n  transition: background-color 0.2s ease;\n}\n\n.table-row:hover {\n  background: #f8f9fa;\n}\n\n.table-row:last-child {\n  border-bottom: none;\n}\n\n.table-row span:nth-child(2) {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.85rem;\n  color: #6c757d;\n}\n\n.table-row span:nth-child(4) {\n  font-weight: 600;\n  color: #28a745;\n}\n\n.emulator-controls h4 {\n  color: #2d3436;\n  margin-bottom: 1rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.controls-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.controls-grid .btn-primary,\n.controls-grid .btn-secondary {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.controls-grid .btn-primary {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n}\n\n.controls-grid .btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n}\n\n.controls-grid .btn-secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.controls-grid .btn-secondary:hover {\n  background: #5a6268;\n  transform: translateY(-2px);\n}\n\n.controls-grid .btn-success {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n}\n\n.controls-grid .btn-success:hover {\n  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);\n  transform: translateY(-2px);\n}\n\n.controls-grid button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.controls-grid button:disabled:hover {\n  transform: none !important;\n}\n\n.emulator-info {\n  background: #e3f2fd;\n  border-left: 4px solid #2196f3;\n  padding: 1rem;\n  border-radius: 4px;\n}\n\n.emulator-info p {\n  margin: 0.5rem 0;\n  color: #1565c0;\n  font-size: 0.9rem;\n}\n\n.emulator-info p:first-child {\n  margin-top: 0;\n}\n\n.emulator-info p:last-child {\n  margin-bottom: 0;\n}\n\n/* Responsividade para o emulador */\n@media (max-width: 768px) {\n  .table-header,\n  .table-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n  \n  .table-header span,\n  .table-row span {\n    border-right: none;\n    border-bottom: 1px solid #dee2e6;\n    padding: 0.5rem 0.75rem;\n  }\n  \n  .table-header span:before,\n  .table-row span:before {\n    content: attr(data-label) \": \";\n    font-weight: 600;\n    display: inline-block;\n    width: 120px;\n  }\n  \n  .connection-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .controls-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.notification-icon {\n  font-size: 3rem;\n  margin-right: 1rem;\n  animation: pulse 2s infinite;\n}\n\n.notification-title h3 {\n  margin: 0;\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.4rem;\n  font-weight: 700;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.notification-title p {\n  margin: 0.5rem 0 0 0;\n  color: #f0f0f0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.notification-content {\n  padding: 1.5rem;\n}\n\n.turbine-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-left: 3px solid #6c757d;\n  border-radius: 6px;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: #adb5bd;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n.detail-value {\n  font-weight: 700;\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1rem;\n}\n\n.detail-value.status-inactive {\n  color: #dc3545;\n  text-shadow: 0 0 8px rgba(220, 53, 69, 0.5);\n}\n\n.detail-value.status-maintenance {\n  color: #ff6b35;\n  text-shadow: 0 0 8px rgba(255, 107, 53, 0.5);\n}\n\n.detail-value.status-operational {\n  color: #28a745;\n  text-shadow: 0 0 8px rgba(40, 167, 69, 0.5);\n}\n\n.notification-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.btn-acknowledge {\n  background: linear-gradient(145deg, #28a745 0%, #1e7e34 100%);\n  border: 2px solid #28a745;\n  color: #ffffff;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  min-width: 120px;\n}\n\n.btn-acknowledge:hover {\n  background: linear-gradient(145deg, #1e7e34 0%, #28a745 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(40, 167, 69, 0.4);\n}\n\n.btn-details {\n  background: linear-gradient(145deg, #007bff 0%, #0056b3 100%);\n  border: 2px solid #007bff;\n  color: #ffffff;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  min-width: 120px;\n}\n\n.btn-details:hover {\n  background: linear-gradient(145deg, #0056b3 0%, #007bff 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(0, 123, 255, 0.4);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-50px) scale(0.9);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n/* Responsividade para mobile */\n@media (max-width: 768px) {\n  .failure-notification-modal {\n    width: 95%;\n    margin: 1rem;\n  }\n  \n  .turbine-details-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .notification-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .btn-acknowledge,\n  .btn-details {\n    width: 100%;\n    max-width: 200px;\n  }\n}\n\n\n\n/* Turbine Simulator Styles */\n.turbine-simulator-panel {\n  padding: 15px;\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  min-height: 100vh;\n  color: #ecf0f1;\n}\n\n.turbine-simulator-panel h2 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: 700;\n  margin-bottom: 20px;\n  text-align: center;\n  font-size: 1.6rem;\n  text-shadow: 0 0 10px rgba(255, 215, 0, 0.3);\n}\n\n/* Interface de Configuração de Aerogerador OPC UA */\n.turbine-config-panel {\n  padding: 30px;\n  background: linear-gradient(135deg, #2a2a2a 0%, #383838 100%);\n  border-radius: 15px;\n  color: #ffffff;\n  min-height: 100vh;\n}\n\n.turbine-config-panel h2 {\n  color: #FFD700;\n  margin-bottom: 30px;\n  font-size: 1.8rem;\n  text-align: center;\n  border-bottom: 2px solid #FFD700;\n  padding-bottom: 15px;\n}\n\n.turbine-config-panel .form-section {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 25px;\n  margin-bottom: 25px;\n}\n\n.turbine-config-panel .form-section h3 {\n  color: #FFD700;\n  margin-bottom: 20px;\n  font-size: 1.3rem;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n  padding-bottom: 10px;\n}\n\n.turbine-config-panel .form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.turbine-config-panel .form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.turbine-config-panel .form-group label {\n  color: #ffffff;\n  font-weight: 600;\n  margin-bottom: 8px;\n  font-size: 0.95rem;\n}\n\n.turbine-config-panel .form-group input,\n.turbine-config-panel .form-group select {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  padding: 12px 15px;\n  color: #ffffff;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n}\n\n.turbine-config-panel .form-group input:focus,\n.turbine-config-panel .form-group select:focus {\n  border-color: #FFD700;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\n}\n\n.turbine-config-panel .form-group input:disabled {\n  background: rgba(0, 0, 0, 0.2);\n  color: #888;\n  cursor: not-allowed;\n}\n\n.turbine-config-panel .url-preview {\n  background: rgba(255, 215, 0, 0.1) !important;\n  border-color: rgba(255, 215, 0, 0.5) !important;\n  color: #FFD700 !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.auth-toggle {\n  margin-bottom: 20px;\n}\n\n.switch-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.switch-label input[type=\"checkbox\"] {\n  margin-right: 12px;\n  transform: scale(1.2);\n}\n\n.auth-fields {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.status-message {\n  padding: 12px 20px;\n  border-radius: 8px;\n  margin: 20px 0;\n  font-weight: 600;\n}\n\n.status-message.success {\n  background: rgba(76, 175, 80, 0.2);\n  border: 1px solid #4CAF50;\n  color: #4CAF50;\n}\n\n.status-message.error {\n  background: rgba(244, 67, 54, 0.2);\n  border: 1px solid #f44336;\n  color: #f44336;\n}\n\n.form-actions {\n  display: flex;\n  gap: 15px;\n  margin-top: 30px;\n  flex-wrap: wrap;\n}\n\n.btn-test {\n  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-test:hover:not(:disabled) {\n  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);\n  transform: translateY(-2px);\n}\n\n.btn-test:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.configured-turbines {\n  margin-top: 40px;\n}\n\n.configured-turbines h3 {\n  color: #FFD700;\n  margin-bottom: 20px;\n  font-size: 1.3rem;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n  padding-bottom: 10px;\n}\n\n.turbines-list {\n  display: grid;\n  gap: 20px;\n}\n\n.turbine-config-item {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.turbine-info h4 {\n  color: #FFD700;\n  margin-bottom: 10px;\n  font-size: 1.1rem;\n}\n\n.turbine-info p {\n  margin: 5px 0;\n  color: #cccccc;\n  font-size: 0.9rem;\n}\n\n.turbine-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-small {\n  padding: 8px 15px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-small.btn-danger {\n  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);\n  color: white;\n}\n\n.btn-small.btn-danger:hover {\n  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);\n  transform: translateY(-1px);\n}\n\n/* Responsividade para telas menores */\n@media (max-width: 768px) {\n  .turbine-config-panel {\n    padding: 20px 15px;\n  }\n\n  .turbine-config-panel .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .turbine-config-item {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .turbine-actions {\n    align-self: stretch;\n  }\n}\n\n.simulator-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 15px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n/* Virtual Turbine Control */\n.virtual-turbine-control {\n  background: rgba(248, 249, 250, 0.05);\n  border-radius: 8px;\n  padding: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.virtual-turbine-control h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  margin-bottom: 12px;\n  font-size: 1.2rem;\n}\n\n.turbine-status-overview {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 15px;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n}\n\n.status-indicator-large {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.status-led-large {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  display: inline-block;\n  box-shadow: 0 0 8px currentColor;\n}\n\n.status-led-large.operational {\n  background: #28a745;\n  box-shadow: 0 0 15px #28a745;\n}\n\n.status-led-large.warning {\n  background: #ffc107;\n  box-shadow: 0 0 15px #ffc107;\n}\n\n.status-led-large.maintenance {\n  background: #17a2b8;\n  box-shadow: 0 0 15px #17a2b8;\n}\n\n.status-led-large.inactive {\n  background: #dc3545;\n  box-shadow: 0 0 15px #dc3545;\n}\n\n.status-text {\n  font-weight: bold;\n  font-size: 0.95rem;\n}\n\n.quick-metrics {\n  display: flex;\n  gap: 10px;\n}\n\n.metric-card {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 8px 12px;\n  border-radius: 4px;\n  text-align: center;\n  min-width: 70px;\n}\n\n.metric-card label {\n  display: block;\n  font-size: 0.85rem;\n  color: #adb5bd;\n  margin-bottom: 5px;\n}\n\n.metric-card span {\n  font-weight: bold;\n  color: #FFD700;\n  font-size: 1rem;\n}\n\n/* Manual Controls */\n.manual-controls h4 {\n  color: #FFD700;\n  margin-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n  padding-bottom: 3px;\n  font-size: 1rem;\n}\n\n.manual-controls .controls-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.control-group {\n  display: grid;\n  grid-template-columns: 1fr 2fr auto;\n  align-items: center;\n  gap: 10px;\n  padding: 8px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 4px;\n}\n\n.control-group label {\n  font-weight: 500;\n  color: #ecf0f1;\n}\n\n.control-group input[type=\"range\"] {\n  background: #495057;\n  height: 8px;\n  border-radius: 4px;\n  outline: none;\n  cursor: pointer;\n}\n\n.control-group input[type=\"range\"]::-webkit-slider-thumb {\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #FFD700;\n  cursor: pointer;\n  box-shadow: 0 0 8px rgba(255, 215, 0, 0.5);\n}\n\n.control-group select {\n  background: #495057;\n  color: #ecf0f1;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  padding: 8px 12px;\n  outline: none;\n}\n\n.control-group span {\n  color: #FFD700;\n  font-weight: bold;\n  min-width: 60px;\n  text-align: right;\n}\n\n/* Fault Simulation */\n.fault-simulation {\n  background: rgba(248, 249, 250, 0.05);\n  border-radius: 8px;\n  padding: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.fault-simulation h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  margin-bottom: 12px;\n  font-size: 1.2rem;\n}\n\n.fault-simulation h4 {\n  color: #FFD700;\n  margin-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n  padding-bottom: 3px;\n  font-size: 1rem;\n}\n\n.fault-form {\n  display: grid;\n  grid-template-columns: 2fr 1fr auto;\n  gap: 10px;\n  margin-bottom: 15px;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n}\n\n.fault-form select {\n  background: #495057;\n  color: #ecf0f1;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  padding: 8px;\n  outline: none;\n  font-size: 0.9rem;\n}\n\n.faults-list {\n  max-height: 250px;\n  overflow-y: auto;\n  margin-bottom: 15px;\n}\n\n.fault-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  margin-bottom: 6px;\n  border-radius: 4px;\n  border-left: 3px solid;\n}\n\n.fault-item.low {\n  background: rgba(40, 167, 69, 0.1);\n  border-left-color: #28a745;\n}\n\n.fault-item.medium {\n  background: rgba(255, 193, 7, 0.1);\n  border-left-color: #ffc107;\n}\n\n.fault-item.high {\n  background: rgba(255, 108, 75, 0.1);\n  border-left-color: #ff6c4b;\n}\n\n.fault-item.critical {\n  background: rgba(220, 53, 69, 0.1);\n  border-left-color: #dc3545;\n}\n\n.fault-info strong {\n  color: #FFD700;\n  display: block;\n  margin-bottom: 3px;\n}\n\n.fault-desc {\n  color: #adb5bd;\n  font-size: 0.9rem;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.fault-time {\n  color: #6c757d;\n  font-size: 0.8rem;\n}\n\n.fault-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.severity-badge {\n  padding: 4px 8px;\n  border-radius: 3px;\n  font-size: 0.7rem;\n  font-weight: bold;\n}\n\n.severity-badge.low {\n  background: #28a745;\n  color: white;\n}\n\n.severity-badge.medium {\n  background: #ffc107;\n  color: #212529;\n}\n\n.severity-badge.high {\n  background: #ff6c4b;\n  color: white;\n}\n\n.severity-badge.critical {\n  background: #dc3545;\n  color: white;\n}\n\n.no-faults {\n  text-align: center;\n  padding: 20px;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n/* OPC UA Integration */\n.opcua-integration {\n  background: rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  border-radius: 6px;\n  text-align: center;\n}\n\n.integration-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin: 10px 0;\n}\n\n.status-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.status-indicator.running {\n  background: #28a745;\n  box-shadow: 0 0 8px #28a745;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .simulator-layout {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n  \n  .fault-form {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .turbine-simulator-panel {\n    padding: 10px;\n  }\n}\n\n\n/* Simulator Card Compact Styles */\n.simulator-card {\n  background: rgba(248, 249, 250, 0.05);\n  border-radius: 8px;\n  padding: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n}\n\n.card-header h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n.status-indicator-compact {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quick-metrics-compact {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.controls-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.controls-column {\n  background: rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  border-radius: 6px;\n}\n\n.controls-column h4 {\n  color: #FFD700;\n  margin-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n  padding-bottom: 3px;\n  font-size: 1rem;\n}\n\n.controls-column h5 {\n  color: #FFD700;\n  margin-bottom: 8px;\n  font-size: 0.9rem;\n}\n\n.controls-grid-compact {\n  display: grid;\n  gap: 10px;\n}\n\n.fault-form-compact {\n  display: grid;\n  grid-template-columns: 1fr 80px auto;\n  gap: 8px;\n  margin-bottom: 15px;\n}\n\n.fault-form-compact select {\n  background: #495057;\n  color: #ecf0f1;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  padding: 6px;\n  outline: none;\n  font-size: 0.85rem;\n}\n\n.btn-compact {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n}\n\n.active-faults-compact {\n  margin-bottom: 15px;\n}\n\n.faults-list-compact {\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.fault-item-compact {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px;\n  margin-bottom: 4px;\n  border-radius: 4px;\n  border-left: 3px solid;\n  font-size: 0.85rem;\n}\n\n.fault-item-compact.low {\n  background: rgba(40, 167, 69, 0.1);\n  border-left-color: #28a745;\n}\n\n.fault-item-compact.medium {\n  background: rgba(255, 193, 7, 0.1);\n  border-left-color: #ffc107;\n}\n\n.fault-item-compact.high {\n  background: rgba(255, 108, 75, 0.1);\n  border-left-color: #ff6c4b;\n}\n\n.fault-item-compact.critical {\n  background: rgba(220, 53, 69, 0.1);\n  border-left-color: #dc3545;\n}\n\n.fault-item-compact .fault-info strong {\n  color: #FFD700;\n  display: block;\n  font-size: 0.8rem;\n}\n\n.fault-item-compact .fault-time {\n  color: #6c757d;\n  font-size: 0.7rem;\n}\n\n.no-faults-compact {\n  text-align: center;\n  padding: 15px;\n  color: #6c757d;\n  font-size: 0.85rem;\n}\n\n.opcua-integration-compact {\n  text-align: center;\n  padding: 8px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n}\n\n.opcua-integration-compact .integration-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 0.85rem;\n}\n\n/* Responsive Design for Compact Layout */\n@media (max-width: 800px) {\n  .controls-section {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n  \n  .fault-form-compact {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n  \n  .quick-metrics-compact {\n    justify-content: center;\n  }\n}\n\n\n/* OPC UA Connection Status Styles */\n.opcua-connection-status {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  border-left: 4px solid #FFD700;\n}\n\n.connection-indicator {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.connection-indicator .status-led {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.connection-indicator.connected .status-led {\n  background: #28a745;\n  box-shadow: 0 0 10px rgba(40, 167, 69, 0.5);\n}\n\n.connection-indicator.disconnected .status-led {\n  background: #dc3545;\n  box-shadow: 0 0 10px rgba(220, 53, 69, 0.5);\n}\n\n.connection-indicator .status-text {\n  color: #FFD700;\n  font-weight: bold;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.connection-indicator .server-address {\n  color: #6c757d;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 0.9rem;\n}\n\n/* Single Turbine Display */\n.single-turbine-display {\n  margin-top: 20px;\n}\n\n.main-turbine-card {\n  background: rgba(248, 249, 250, 0.05);\n  border-radius: 12px;\n  padding: 25px;\n  border: 2px solid rgba(255, 215, 0, 0.3);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.turbine-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid rgba(255, 215, 0, 0.5);\n}\n\n.turbine-header h3 {\n  color: #FFD700;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-size: 1.8rem;\n  margin: 0;\n}\n\n.turbine-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.metric-card.primary {\n  grid-column: span 2;\n  background: rgba(255, 215, 0, 0.1);\n  border: 2px solid #FFD700;\n}\n\n.metric-card.primary .value {\n  font-size: 2.5rem;\n  color: #FFD700;\n}\n\n.turbine-details {\n  background: rgba(0, 0, 0, 0.2);\n  padding: 20px;\n  border-radius: 8px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.detail-row .label {\n  color: #adb5bd;\n  font-weight: 500;\n}\n\n.detail-row .value {\n  color: #ecf0f1;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Connected/Disconnected Status Colors */\n.metric-value.connected {\n  color: #28a745 !important;\n}\n\n.metric-value.disconnected {\n  color: #dc3545 !important;\n}\n\n/* Estilos para o Sistema de Gerenciamento de Alarmes */\n.alarms-management-panel {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n  padding: 2rem;\n  margin: 1rem;\n  color: #ecf0f1;\n}\n\n.alarms-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid rgba(255, 215, 0, 0.3);\n}\n\n.alarms-header h2 {\n  color: #FFD700;\n  margin: 0;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.alarms-summary {\n  display: flex;\n  gap: 1rem;\n}\n\n.alarm-counter {\n  background: rgba(0, 0, 0, 0.4);\n  padding: 1rem;\n  border-radius: 8px;\n  text-align: center;\n  min-width: 100px;\n  border: 2px solid transparent;\n}\n\n.alarm-counter.active {\n  border-color: #dc3545;\n  background: rgba(220, 53, 69, 0.1);\n}\n\n.alarm-counter.total {\n  border-color: #6c757d;\n  background: rgba(108, 117, 125, 0.1);\n}\n\n.counter-value {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.counter-label {\n  display: block;\n  font-size: 0.9rem;\n  color: #adb5bd;\n  margin-top: 0.5rem;\n}\n\n.active-alarms-section,\n.historical-alarms-section {\n  margin-bottom: 2rem;\n}\n\n.active-alarms-section h3,\n.historical-alarms-section h3 {\n  color: #FFD700;\n  margin-bottom: 1rem;\n  font-size: 1.4rem;\n}\n\n.alarms-table {\n  background: rgba(0, 0, 0, 0.4);\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 150px 200px 300px 150px 120px 120px;\n  background: rgba(255, 215, 0, 0.1);\n  padding: 1rem;\n  font-weight: 600;\n  color: #FFD700;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n}\n\n.table-body {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.alarm-row {\n  display: grid;\n  grid-template-columns: 150px 200px 300px 150px 120px 120px;\n  padding: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: background-color 0.2s ease;\n}\n\n.alarm-row:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.alarm-row.failure {\n  border-left: 4px solid #dc3545;\n}\n\n.alarm-row.alert {\n  border-left: 4px solid #ffc107;\n}\n\n.col-time,\n.col-turbine,\n.col-description,\n.col-type,\n.col-status,\n.col-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.turbine-id {\n  font-weight: 600;\n  color: #fff;\n}\n\n.turbine-model {\n  font-size: 0.85rem;\n  color: #adb5bd;\n}\n\n.alarm-type-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.alarm-type-badge.warning {\n  background: rgba(255, 193, 7, 0.2);\n  color: #ffc107;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.alarm-type-badge.maintenance {\n  background: rgba(23, 162, 184, 0.2);\n  color: #17a2b8;\n  border: 1px solid rgba(23, 162, 184, 0.3);\n}\n\n.alarm-type-badge.inactive {\n  background: rgba(220, 53, 69, 0.2);\n  color: #dc3545;\n  border: 1px solid rgba(220, 53, 69, 0.3);\n}\n\n.status-badge {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.status-badge.pending {\n  background: rgba(220, 53, 69, 0.2);\n  color: #dc3545;\n  border: 1px solid rgba(220, 53, 69, 0.3);\n}\n\n.status-badge.acknowledged {\n  background: rgba(40, 167, 69, 0.2);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.btn-acknowledge {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-acknowledge:hover {\n  background: #218838;\n  transform: translateY(-1px);\n}\n\n.no-alarms {\n  text-align: center;\n  padding: 3rem;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  border: 2px dashed rgba(255, 255, 255, 0.2);\n}\n\n.no-alarms-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.no-alarms h4 {\n  color: #28a745;\n  margin-bottom: 0.5rem;\n}\n\n.no-alarms p {\n  color: #adb5bd;\n  margin: 0;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.period-selector {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  background: rgba(0, 0, 0, 0.3);\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.period-selector label {\n  color: #adb5bd;\n  font-weight: 600;\n}\n\n.date-input {\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  padding: 0.5rem;\n  border-radius: 4px;\n  font-family: inherit;\n}\n\n.date-input:focus {\n  outline: none;\n  border-color: #FFD700;\n  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\n}\n\n.btn-extract {\n  background: #FFD700;\n  color: #000;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-extract:hover {\n  background: #ffc107;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);\n}\n\n.historical-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.summary-card {\n  background: rgba(0, 0, 0, 0.4);\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.summary-icon {\n  font-size: 2.5rem;\n  opacity: 0.8;\n}\n\n.summary-content h4 {\n  color: #FFD700;\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n}\n\n.summary-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0;\n  text-align: center;\n}\n\n.summary-label {\n  color: #adb5bd;\n  font-size: 0.8rem;\n  margin: 0;\n  text-align: center;\n}\n\n/* Sistema de Análise de Dados OPC */\n.analysis-panel {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);\n  color: #ffffff;\n  min-height: calc(100vh - 75px);\n}\n\n.analysis-header {\n  margin-bottom: 2rem;\n}\n\n.analysis-header h2 {\n  color: #FFD700;\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  letter-spacing: 1px;\n}\n\n.analysis-header p {\n  color: #adb5bd;\n  font-size: 1rem;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.export-options {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.export-section {\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.export-section h3 {\n  color: #FFD700;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0 0 1rem 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.selection-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.selection-option {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-left: 3px solid #6c757d;\n  border-radius: 6px;\n  padding: 1rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.selection-option:hover {\n  border-left-color: #FFD700;\n  background: rgba(255, 215, 0, 0.1);\n}\n\n.selection-option input[type=\"radio\"] {\n  margin-right: 0.75rem;\n  scale: 1.2;\n}\n\n.selection-option label {\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  margin: 0;\n}\n\n.option-title {\n  font-weight: 600;\n  color: #fff;\n  font-size: 1rem;\n  margin-bottom: 0.25rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.option-description {\n  color: #adb5bd;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.period-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.date-range {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.date-range label {\n  color: #adb5bd;\n  font-weight: 500;\n  font-size: 0.95rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.date-range input {\n  padding: 0.75rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  font-size: 0.95rem;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  transition: border-color 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.date-range input:focus {\n  outline: none;\n  border-color: #FFD700;\n  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);\n}\n\n.variables-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.variable-category {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  padding: 1rem;\n}\n\n.variable-category h4 {\n  color: #FFD700;\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 0.75rem 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.variable-category label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n  color: #adb5bd;\n  font-size: 0.9rem;\n  padding: 0.25rem 0;\n  transition: color 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.variable-category label:hover {\n  color: #fff;\n}\n\n.variable-category input[type=\"checkbox\"] {\n  scale: 1.1;\n}\n\n.format-grid {\n  display: flex;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.format-grid label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  padding: 0.75rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #adb5bd;\n  transition: all 0.3s ease;\n  min-width: 150px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.format-grid label:hover {\n  border-color: #FFD700;\n  background: rgba(255, 215, 0, 0.1);\n  color: #fff;\n}\n\n.format-grid input[type=\"radio\"] {\n  scale: 1.2;\n}\n\n.export-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.preview-button, .export-button {\n  padding: 0.75rem 2rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.preview-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid #495057;\n  color: #adb5bd;\n}\n\n.preview-button:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: #FFD700;\n  color: #FFD700;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);\n}\n\n.export-button {\n  background: #FFD700;\n  border: 1px solid #FFD700;\n  color: #2d3436;\n}\n\n.export-button:hover {\n  background: #ffc107;\n  border-color: #ffc107;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);\n}\n\n.export-info {\n  margin-top: 1rem;\n}\n\n.info-card {\n  background: rgba(33, 150, 243, 0.1);\n  border: 1px solid rgba(33, 150, 243, 0.3);\n  border-radius: 6px;\n  padding: 1rem;\n}\n\n.info-card h4 {\n  color: #64b5f6;\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0 0 0.75rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.info-card ul {\n  margin: 0;\n  padding-left: 1.25rem;\n  color: #adb5bd;\n}\n\n.info-card li {\n  margin-bottom: 0.25rem;\n  font-size: 0.9rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
